<template>
  <div :id=devControl>
    <el-container>
      <ResizeBox :class=man_li>
        <el-tree :data="treeData" :props="defaultProps" node-key="id" :default-expanded-keys="defKey"
                 :class=my_treeCtr @node-click="handleNodeClick" :expand-on-click-node="false"
                 :render-content="renderContent" icon-class="el-icon-caret-right" :highlight-current="true">
        </el-tree>
      </ResizeBox>
      <el-container :class=my_main> <!--头部总控-->
        <el-header :class=li_head style="font-size: 12px">
          <span style="margin-left:0; color: #ffffff; font-size: 13px">
            <el-select v-model="edi_state" ref='select1' @change="devSx()"
                       @visible-change='show_change1'
                       clearable filterable :placeholder="$t('设备状态')"
                       style="height:10px; width:10vw;">
              <el-option
                v-for="item in state_options"
                :key="item.value"
                :label="$t(item.label)"
                :value="item.value">
                <!--@click.native="show_table(httpData,roomData)"-->
              </el-option>
            </el-select>
          </span>
          <span style="margin-left:1px; color: #ffffff; font-size: 13px">
            <el-input
              :placeholder="$t('设备名称')"
              style="width: 10vw"
              prefix-icon="el-icon-search"
              @keyup.enter.native="devSx"
              @clear="devSx"
              clearable
              v-model="dev_name1">
            </el-input>
          </span>
          <span style="margin-left:1px; color: #ffffff; font-size: 13px">
             <el-select v-model="edi_pwr" ref='select2' @change="devSx()"
                        @visible-change='show_change2'
                        clearable filterable :placeholder="$t('开关状态')"
                        style="height:10px; width:10vw;">
               <el-option
                 v-for="item in pwr_options"
                 :key="item.value"
                 :label="$t(item.label)"
                 :value="item.value">
                 <!--@click.native="show_table(httpData,roomData)"-->
               </el-option>
             </el-select>
          </span>
        </el-header>
        <div style="background: #0dA7C8;height: 1px"></div>
        <el-main :class=head_liman>
          <div :class=grid_box :style="divStyle">
            <div :class=grid_item v-for="site in sites">
              <div style="padding-left: 5px;padding-right: 5px">
                <div class="thermostat-container">
                  <!-- 顶部状态栏 -->
                  <div class="status-bar">
                    <div class="left-group">
                      <div class="id-badge">
                        <span :class="['id-text', site.pwr && site.online === 88 ? 'id-text-on' : '']"
                              @click="on_name(site)"
                              :title="site.floor_name + '/' + site.room_name + '/' + site.dev_name">{{
                            site.floor_name
                          }}/{{
                            site.room_name
                          }}/{{ site.dev_name }}</span>
                      </div>
                    </div>
                    <div class="power-status">
                      <span v-if="site.stop_logo===1"
                            style="color:#ff4d4d; font-size: 12px; margin-right: 3px; font-weight: bold;">{{
                          $t('停机')
                        }}</span>
                      <el-tooltip v-if="site.stop_czTime===1" effect="dark" :content="$t('插卡')" placement="bottom">
                        <i :class="site.icon_gjd" style="font-size: 16px; margin-right: 3px;"></i>
                      </el-tooltip>
                      <el-tooltip effect="dark" :content="site.dev_status" placement="bottom">
                        <i :class="site.icon_tx" style="font-size: 16px; margin-right: 3px;"></i>
                      </el-tooltip>
                      <el-tooltip v-if="site.xh != null" effect="dark" :content="''+site.xh" placement="bottom">
                        <i :class="site.icon_xh" style="font-size: 16px; margin-right:0;"></i>
                      </el-tooltip>
                    </div>
                  </div>

                  <!-- 显示屏幕 -->
                  <div
                    :class="['display-screen', (pendingVal(site,'pwr') !== undefined ? pendingVal(site,'pwr') : site.pwr) && site.online === 88 ? 'screen-on' : '', site.online !== 88 ? 'offline' : '']"
                    @click="openKtDialog(site)" style="cursor: pointer;" :title="$t('点击打开控制面板')">
                    <div class="display-top">
                      <div class="mode-section">
                        <span class="t-label">{{ $t('模式') }}</span>
                        <span class="mode-text">{{ getModeText(site) }}</span>
                      </div>
                      <div v-if="(isLockEnabled(site.pid) || isDljLockEnabled(site.pid)) && site.kt_lock"
                           class="mode-section">
                        <span class="t-label">{{ getLockLabel(site) }}</span>
                      </div>
                      <div class="setting-section">
                        <span class="t-label">{{ $t('设定') }}</span>
                        <span style="font-size:16px">{{
                            typeof (pendingVal(site,'temp_set') !== undefined ? pendingVal(site,'temp_set'):site.temp_set) === 'number' ? (pendingVal(site,'temp_set') !== undefined ? pendingVal(site,'temp_set'):site.temp_set).toFixed(1):(pendingVal(site,'temp_set') !== undefined ? pendingVal(site,'temp_set'):site.temp_set)
                          }}℃</span>
                      </div>
                    </div>

                    <div class="main-temp">
                        <span class="big-num">{{
                            typeof site.temp === 'number' ? site.temp.toFixed(1):site.temp
                          }}</span>
                      <div class="temp-unit">
                        <span>℃</span>
                        <span class="sub-label">{{ $t('室内') }}</span>
                      </div>
                    </div>

                    <div class="display-bottom">
                      <span>
                        {{ getSfText(site) }}
                      </span>
                      <span>{{ site.uptime }}</span>
                      <span>{{ getFanText(site) }}</span>
                    </div>
                  </div>

                  <!-- 底部按钮组 -->
                  <div class="button-group">
                    <button class="control-btn" @click="Onclick(site.id,'pwr')">
                      <i :class="bj === '1' ? 'kt_pwr1' : 'kt_pwr'" style="font-size: 16px"></i>
                    </button>
                    <button class="control-btn" @click="OnMode(site.id,'mode')">
                      <i :class="bj === '1' ? 'kt_mode1' : 'kt_mode'" style="font-size: 16px"></i>
                    </button>
                    <button class="control-btn" @click="OnFan(site.id,'fszd')">
                      <i :class="bj === '1' ? 'kt_fan1' : 'kt_fan'" style="font-size: 16px"></i>
                    </button>
                    <button class="control-btn"
                            @click="OnTemp(site.id,'tempAdd')">
                      <i :class="bj === '1' ? 'kt_up1' : 'kt_up'" style="font-size: 16px"></i>
                    </button>
                    <button class="control-btn"
                            @click="OnTemp(site.id,'tempDel')">
                      <i :class="bj === '1' ? 'kt_down1' : 'kt_down'" style="font-size: 16px"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-main>
        <el-pagination
          style="float:right; margin-left:0.5vw;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[30, 100, 1000, 2000]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
        <el-footer style="margin-bottom: 3px">
        </el-footer> <!--grid加底部去除遮挡-->
      </el-container>
    </el-container>
    <el-dialog :title="$t('锁定设置')" center :close-on-click-modal="false"
               width="400px" height="600px" :class=bj_daiLog
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='dailogShow'> <!--v-draggable 拖动-->
      <div v-if="sd_type==='dlj'">
        <div style="margin-top:0px;">
          <span>{{ $t('开关：') }}</span>
          <el-radio-group v-model="xz_kg" size="small">
            <el-radio-button label="开机">{{ $t('开机') }}</el-radio-button>
            <el-radio-button label="关机">{{ $t('关机') }}</el-radio-button>
            <el-radio-button label="不锁">{{ $t('不锁') }}</el-radio-button>
          </el-radio-group>
        </div>
        <div style="margin-top: 10px">
          <span>{{ $t('模式：') }}</span>
          <el-radio-group v-model="xz_mode" size="small">
            <el-radio-button label="制热">{{ $t('制热') }}</el-radio-button>
            <el-radio-button label="制冷">{{ $t('制冷') }}</el-radio-button>
            <el-radio-button label="送风">{{ $t('送风') }}</el-radio-button>
            <el-radio-button label="除湿">{{ $t('除湿') }}</el-radio-button>
            <el-radio-button label="不锁">{{ $t('不锁') }}</el-radio-button>
          </el-radio-group>
        </div>
        <div style="margin-top: 10px">
          <span>{{ $t('风速：') }}</span>
          <el-radio-group v-model="xz_fan" size="small">
            <el-radio-button label="低风">{{ $t('低风') }}</el-radio-button>
            <el-radio-button label="中风">{{ $t('中风') }}</el-radio-button>
            <el-radio-button label="高风">{{ $t('高风') }}</el-radio-button>
            <el-radio-button label="自动">{{ $t('自动') }}</el-radio-button>
            <el-radio-button label="不锁">{{ $t('不锁') }}</el-radio-button>
          </el-radio-group>
        </div>
        <div style="margin-top: 10px">
          <span>{{ $t('温度：') }}</span>
          <input :placeholder="$t('最低')" style="width:50px;height:30px;text-align:center" v-model="xz_temp_min"
                 type="number"></input>
          <span>-</span>
          <input :placeholder="$t('最高')" style="width:50px;height:30px;text-align:center" v-model="xz_temp_max"
                 type="number"></input>
        </div>
        <div style="margin-top: 20px;">
          <button @click="dialog_Onclick('退出')" v-bind:style="{background:dailog_qxbg,color:bj_but_color, fontSize:'15px',border: '1px solid #0dA7C8',
                          width:'60px',height:'36px'}">{{ $t('退出') }}
          </button>
          <button @click="dialog_Onclick('锁定')" v-bind:style="{background:dailog_qdbg,color:bj_but_color, fontSize:'15px',border: '1px solid #0dA7C8',
                          width:'60px',height:'36px'}">{{ $t('锁定') }}
          </button>
        </div>
      </div>
      <div v-else>
        <div style="margin-top:0px;">
          <span>{{ $t('锁定功能') }}：</span>
          <el-radio-group v-model="sj_sd_kg" size="small">
            <el-radio-button label="全锁">{{ $t('全锁') }}</el-radio-button>
            <!--            <el-radio-button label="关机"></el-radio-button>-->
            <!--            <el-radio-button label="半锁"></el-radio-button>-->
            <el-radio-button label="解锁">{{ $t('解锁') }}</el-radio-button>
          </el-radio-group>
          <button @click="dialog_sj_sd('开关')" v-bind:style="{background:dailog_qdbg,color:bj_but_color, marginLeft:'50px',fontSize:'15px',border: '1px solid #0dA7C8',
                    width:'60px',height:'36px'}">{{ $t('发送') }}
          </button>
        </div>
        <div style="margin-top: 20px">
          <span>{{ $t('制冷温度') }}：</span>
          <input :placeholder="$t('最低')" style="width:50px;height:30px;text-align:center" v-model="sj_xz_temp_min"
                 type="number"></input>
          <span>-</span>
          <input :placeholder="$t('最高')" style="width:50px;height:30px;text-align:center" v-model="sj_xz_temp_max"
                 type="number"></input>
          <button @click="dialog_sj_sd('温度')" v-bind:style="{background:dailog_qdbg,color:bj_but_color, marginLeft:'31px',fontSize:'15px',border: '1px solid #0dA7C8',
                    width:'60px',height:'36px'}">{{ $t('发送') }}
          </button>
        </div>
        <div style="margin-top: 10px">
          <span>{{ $t('制热温度') }}：</span>
          <input :placeholder="$t('最低')" style="width:50px;height:30px;text-align:center" v-model="sj_xz_temp_min1"
                 type="number"></input>
          <span>-</span>
          <input :placeholder="$t('最高')" style="width:50px;height:30px;text-align:center" v-model="sj_xz_temp_max1"
                 type="number"></input>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="$t('历史记录')" center :close-on-click-modal="false"
               width="700px" height="600px" :class=bj_daiLog
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='dailogShow_ls'> <!--v-draggable 拖动-->
      <div style="margin-left:0;">
        <el-date-picker
          v-model="xz_date"
          @change="upDate"
          type="daterange"
          format="yyyy-MM-dd"
          :clearable="false"
          range-separator="至"
          :start-placeholder="$t('开始日期')"
          :end-placeholder="$t('结束日期')">
        </el-date-picker>
      </div>
      <div style="margin-top:10px;">
        <el-table :data=tableData :class=bj_table :cell-style="tableYs" border
                  style="width:100%; font-size:11px;"
                  height="60vh" show-overflow-tooltip
                  :header-cell-style="{'text-align':'center','background':this.bj_tab,'color':this.bj_tab_color}">
          <el-table-column width="01" sortable/>
          <div v-for="d in this.defHead">
            <el-table-column
              :prop=d.val :label="$t(d.key)" sortable>
            </el-table-column>
          </div>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :title="$t('设备信息')" center :close-on-click-modal="false"
               width="300px" height="600px" :class=bj_daiLog
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='dailogchange'> <!--v-draggable 拖动-->
      <div style="margin-top:20px;">
        <span>{{ $t('设备类型') }}：</span>
        <el-select v-model="edi_dev_type" ref='select1'
                   filterable :placeholder="$t('请选择')"
                   style="height:10px;width:160px; margin-left:0">
          <el-option
            v-for="item in dev_type_list"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div v-if="area_max==='area'" style="margin-top:20px;">
        <span>{{ $t('所属小区') }}：</span>
        <el-select v-model="edi_area" ref='selectArea'
                   filterable :placeholder="$t('请选择')"
                   style="height:10px;width:160px; margin-left:0"
                   @change="area_xz()">
          <el-option
            v-for="item in area_list"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div v-if="area_max==='area'||area_max==='building'" style="margin-top:20px;">
        <span>{{ $t('所属楼栋') }}：</span>
        <el-select v-model="edi_building" ref='selectBuild'
                   filterable :placeholder="$t('请选择')"
                   style="height:10px;width:160px; margin-left:0"
                   @change="building_xz()">
          <el-option
            v-for="item in building_list"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div v-if="area_max==='area'||area_max==='building'||area_max==='unit'" style="margin-top:20px;">
        <span>{{ $t('所属单元') }}：</span>
        <el-select v-model="edi_unit" ref='select1'
                   filterable :placeholder="$t('请选择')"
                   style="height:10px;width:160px; margin-left:0"
                   @change="unit_xz()">
          <el-option
            v-for="item in unit_list"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="margin-top:20px;">
        <span>{{ $t('所属楼层') }}：</span>
        <el-select v-model="edi_floor" ref='select1'
                   filterable :placeholder="$t('请选择')"
                   style="height:10px;width:160px; margin-left:0"
                   @change="floor_xz()">
          <el-option
            v-for="item in fil_floor"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="margin-top:20px;">
        <span>{{ $t('所属房间') }}：</span>
        <el-select v-model="edi_room" ref='select2'
                   filterable :placeholder="$t('请选择')"
                   style="height:10px;width:160px; margin-left:0">
          <el-option
            v-for="item in fil_room"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="margin-top:20px;">
        <span>{{ $t('设备名称') }}：</span>
        <el-input :placeholder="$t('请输入栋层名称')" style="width:160px;height:30px;" v-model="dev_name"></el-input>
      </div>
      <div style="margin-top:20px;">
        <span>{{ $t('所属网关') }}：</span>
        <el-select v-model="edi_mac" disabled ref='select3'
                   filterable :placeholder="$t('请选择')"
                   style="height:10px;width:160px; margin-left:0">
          <el-option
            v-for="item in mac_list"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="margin-top:20px;">
        <span>{{ $t('设备ID') }}：</span>
        <el-input :disabled="true" :placeholder="$t('设备id')" style="width:160px;height:30px;margin-left:13px"
                  v-model="d_qid"></el-input>
      </div>
      <div style="margin-top:20px;">
        <span>{{ $t('备注信息') }}：</span>
        <el-input :placeholder="$t('备注')" style="width:160px;height:30px;" v-model="dev_bz"></el-input>
      </div>
      <div style="margin-top:30px;">
        <button @click="dialog_Change('退出')" v-bind:style="{background:dailog_qxbg,color:bj_but_color, fontSize:'15px',border: '1px solid #0dA7C8',
                          width:'60px',height:'36px'}">{{ $t('退出') }}
        </button>
        <button @click="dialog_Change('保存')" v-bind:style="{background:dailog_qdbg,color:bj_but_color, fontSize:'15px',marginLeft:'110px',
          border: '1px solid #0dA7C8', width:'60px',height:'36px'}">{{ $t('保存') }}
        </button>
      </div>
    </el-dialog>
    <el-dialog :title="$t(txt_title)" center :close-on-click-modal="false"
               width="300px" height="600px" :class=bj_daiLog
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='dai_area'> <!--v-draggable 拖动-->
      <div style="margin-left:0;">
        <span>{{ $t(txt_name) }}</span>
        <el-input :placeholder="$t('请输入名称')" style="width:150px;height:30px;" v-model="edi_name"></el-input>
      </div>
      <div style="margin-top:30px;width:100%;display:flex;align-items:center">
        <el-button @click="dai_area=false" style="margin-left:auto">{{ $t('退出') }}
        </el-button>
        <el-button @click="keep_area" type="primary"
                   style="margin-left:10px;margin-right:10px">{{ $t('保存') }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('提示')"
      :visible.sync="dialogVisible"
      width="30%">
      <span>{{ $t(delTip) }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('取 消') }}</el-button>
        <el-button type="primary" @click=del_area()>{{ $t('确 定') }}</el-button>
      </span>
    </el-dialog>
    <!-- 空调控制弹窗 -->
    <dia-kt-ctr
      :visible.sync="diaKtVisible"
      :site-data="diaKtSite"
      :pid-mode-map="pidModeMap"
      :pid-fan-map="pidFanMap"
      :pid-lock-map="pidLockMap"
      :pid-temp-limit-map="pidTempLimitMap"
      :pid-dlj-lock="pidDljLock"
      :bj="bj"
      @control="onDialogControl"
      @sendLock="onDialogLock"
      @sendTempLimit="onDialogTempLimit"
      @sendDljBatchLock="onDialogDljBatchLock"
      @sendDljBatchUnlock="onDialogDljBatchUnlock"
      @showLog="openLogDevDialog"
    />
    <!-- 控制日志弹窗 -->
    <dia-log-dev
      :visible.sync="diaLogDevVisible"
      :site-data="diaLogDevSite"
      :bj="bj"
    />
  </div>
</template>

<script>
import draggable from '@/utils/draggable';
import ResizeBox from "@/utils/ResizeBox.vue";
import DiaKtCtr from '@/dialog/diaKtCtr.vue';
import DiaLogDev from '@/dialog/diaLogDev.vue';
import moment from "moment";
import mqtt from 'mqtt/dist/mqtt.js';

export default {
  name:'devControl',
  components:{
    ResizeBox:ResizeBox,
    DiaKtCtr:DiaKtCtr,
    DiaLogDev:DiaLogDev
  },
  directives:{
    draggable /*dialog增加移动*/
  },
  data() {
    return {
      bj:'',
      li_id:[],
      li_mac:[],
      old_m:new Date().getMinutes(),
      divStyle:{
        marginLeft:'15px',
        maxHeight:window.innerHeight - 140
      },
      client:null,
      topics:[],
      messages:{},
      delTip:"您确定要删除此区域吗？",
      txt_name:"",
      edi_name:"",
      txt_title:"",
      dai_area:false,
      dialogVisible:false,
      xz_id:"",
      list_floor:[],
      list_room:[],
      area_max:"floor",
      xz_area:"all",
      area_list1:[],
      edi_dev_type:"",
      dev_type_list:[],
      changeName:false,
      total:0,
      page:1,
      pageSize:30,
      dev_name1:"",
      dev_name:"",
      edi_state:"",
      state_options:[
        {
          value:'在线',
          label:'在线'
        },
        {
          value:'离线',
          label:'离线'
        }
      ],
      edi_pwr:"",
      pwr_options:[
        {
          value:1,
          label:'开机'
        },
        {
          value:0,
          label:'关机'
        }
      ],
      kt_qx:true,
      msg:"ddddd",
      isOne:true,
      dailogchange:false,
      d_qid:'',
      dev_bz:'',
      maxArea_id:-1,
      params:[{}],
      edi_mac:"",
      mac_list:[{}],
      unit_list:[],
      edi_area:"",
      area_list:[{}],
      edi_building:"",
      building_list:[{}],
      edi_unit:"",
      list_unit:[{}],
      edi_floor:"",
      li_floor:[{}],
      edi_room:"",
      li_room:[{}],
      cz_pwr:1,
      cz_id:-1,
      sd_type:"sj",
      dialogCz:false,
      cz_form:{name:""},
      formLabelWidth:'100px',
      czinfo_list:[],
      dailogShow_ls:false,
      xz_date:[],
      roomid:0,
      tableData:[],
      defHead:[
        {'key':"操作时间",'val':"uptime"},
        {'key':"操作来源",'val':"ctr_type"},
        {'key':"操作类型",'val':"set_type"},
        {'key':"操作内容",'val':"set_val"},
        {'key':"操作结果",'val':"res"}
      ],
      xz_kg:"开机",
      sj_sd_kg:"全锁",
      xz_mode:"制热",
      xz_fan:"低风",
      xz_temp_min:"17",
      xz_temp_max:"32",
      sj_xz_temp_min:"17",
      sj_xz_temp_max:"32",
      sj_xz_temp_min1:"17",
      sj_xz_temp_max1:"32",
      dailog_qxbg:"#283A4D",
      dailog_qdbg:"#283A4D",
      dailog_xzVlue:-1, /*判断当前选择表格 -1为总控*/
      dailogShow:false, /*多联机锁定*/
      roomData:"",
      defKey:[-1],
      treeData:[
        {id:2}
      ],
      defaultProps:{
        children:'children',
        label:'label'
      },
      ld_list:[],
      lc_list:[],
      sx_familyId:"", /*floor_name、room_name、dev_name*/
      sx_familyName:"", /*选择的房间，用来筛选列表界面数据*/
      checkAll:false, /*全选*/
      checkList:[], /*选中状态*/
      isUpdate:true, /*判断是否可以更新数据*/
      timer_temp:null,
      timer_pwr:null,
      timer_mode:null,
      timer_fan:null,
      diaKtVisible:false, /*空调控制弹窗显示状态*/
      diaKtSite:{}, /*当前弹窗控制的设备数据*/
      diaLogDevVisible:false, /*控制日志弹窗显示状态*/
      diaLogDevSite:{}, /*当前控制日志弹窗的设备数据*/
      tempLimitLockPreserve:{}, /*发送温度限制后，保留原锁定状态避免自动变半锁 {siteId: kt_lock}*/
      pendingMap:{}, /*待确认状态 {siteId: {pwr|mode|fan_set|temp_set: value, timer: timeoutId}}*/
      /* ===== PID对应水阀显示映射，默认无水阀；kf开关文字(0阀关/1阀开)，num直接显示数值 ===== */
      pidSfMap:{
        'sj':{type:'kf'},
        'sj_mnl_zl':{type:'kf'},
        'sj_mnl_gjd':{type:'num'}
      },
      pidSj:[
        "sj",
        "sj_hw_new",
        "sj_mnl_zl",
        "sj_mnl_gjd"
      ],
      /* ===== PID对应模式字典 {pid: [{value,label},...]} ===== */
      pidModeMap:{
        'sj_dn':[
          {value:0,label:'地暖'},
          {value:1,label:'制热'},
          {value:2,label:'同步'},
          {value:3,label:'送风'},
          {value:4,label:'制冷'}
        ],
        'sj_ktdn':[
          {value:0,label:'地暖'},
          {value:1,label:'制热'},
          {value:2,label:'同步'},
          {value:3,label:'送风'},
          {value:4,label:'制冷'}
        ],
        'dlj':[
          {value:1,label:'制热'},
          {value:2,label:'制冷'},
          {value:3,label:'送风'},
          {value:4,label:'除湿'}
        ],
        'kt_kl':[
          {value:1,label:'制热'},
          {value:2,label:'制冷'},
          {value:3,label:'送风'},
          {value:4,label:'除湿'}
        ],
        'default':[
          {value:1,label:'制热'},
          {value:2,label:'制冷'},
          {value:3,label:'送风'}
        ]
      },
      /* ===== PID对应风速字典 {pid: {max, displayToFanSet, labels}} ===== */
      pidFanMap:{
        'york':{max:11,displayToFanSet:{1:4,2:5,3:6,4:7,5:8,6:9,7:10,8:11,9:12,10:13,11:14},labels:{11:'自动'}},
        'sj_mnl_zl':{max:6,displayToFanSet:{1:1,2:2,3:3,4:4,5:5,6:10},labels:{6:'自动'}},
        'sj_mnl_gjd':{max:6,displayToFanSet:{1:1,2:2,3:3,4:4,5:5,6:10},labels:{6:'自动'}},
        'default':{max:4,displayToFanSet:{1:1,2:2,3:3,4:4},labels:{1:'低风',2:'中风',3:'高风',4:'自动'}}
      },
      /* ===== PID对应锁定设置配置 {pid: {show, lockList}} =====
       show: 是否显示锁定设置区域
       lockList: 该PID下可用的锁定选项列表，不填则使用默认列表 ===== */
      pidLockMap:{
        'york':{
          show:true,
          lockList:[
            {value:1,label:'全锁'},
            {value:0,label:'解锁'}
          ]
        },
        'kt_midea':{
          show:true,
          lockList:[
            {value:1,label:'全锁'},
            {value:0,label:'解锁'}
          ]
        },
        'dlj':{
          show:false,
          lockList:[
            {value:1,label:'锁定'},
            {value:0,label:''}
          ]
        },
        'kt_kl':{
          show:false,
          lockList:[
            {value:1,label:'锁定'},
            {value:0,label:''}
          ]
        },
        'default':{
          show:true,
          lockList:[
            {value:3,label:'全锁'},
            {value:1,label:'半锁'},
            {value:0,label:'解锁'}
          ]
        }
      },
      /* ===== PID对应温度限制配置 {pid: {show, minTemp, maxTemp, step}} =====
       show: 是否显示温度限制区域
       minTemp: 最低可调温度
       maxTemp: 最高可调温度
       step: 温度加减调节间隔（默认 0.5） ===== */
      pidTempLimitMap:{
        'york':{show:false,minTemp:10,maxTemp:50,step:0.5},
        'kt_kl':{show:false,minTemp:10,maxTemp:50,step:0.5},
        'kt_midea':{show:false,minTemp:10,maxTemp:50,step:0.5},
        'dlj':{show:true,minTemp:10,maxTemp:50,step:1},
        'default':{show:true,minTemp:10,maxTemp:50,step:0.5}
      },
      /* ===== PID对应多联机锁定显示控制 {pid: {show}} =====
       show: 是否显示多联机锁定面板（各行独立锁定）
       与pidLockMap中的普通锁定（全锁/半锁/解锁）及温度限制互斥 ===== */
      pidDljLock:{
        'dlj':{show:true},
        'default':{show:false}
      },
      sites:[], /*表格布局内容*/
      edi_kg:"",
      isZJ_show:true,
      kg_options:[
        {
          value:'开机',
          label:'开机'
        },
        {
          value:'关机',
          label:'关机'
        }
      ],
      edi_mode:"",
      mode_options:[
        {
          value:'制热',
          label:'制热'
        },
        {
          value:'制冷',
          label:'制冷'
        },
        {
          value:'送风',
          label:'送风'
        },
        {
          value:'除湿',
          label:'除湿'
        }
      ],
      edi_fan:"",
      fan_options:[
        {
          value:'低速',
          label:'低速'
        },
        {
          value:'中速',
          label:'中速'
        },
        {
          value:'高速',
          label:'高速'
        },
        {
          value:'自动',
          label:'自动'
        }
      ],
      edi_sd:"",
      sd_options:[
        {
          value:'锁定',
          label:'锁定'
        },
        {
          value:'解锁',
          label:'解锁'
        }
      ],
      edi_temp:"",
      temp_options:[
        {
          value:16,
          label:16
        },
        {
          value:17,
          label:17
        },
        {
          value:18,
          label:18
        },
        {
          value:19,
          label:19
        },
        {
          value:20,
          label:20
        },
        {
          value:21,
          label:21
        },
        {
          value:22,
          label:22
        },
        {
          value:23,
          label:23
        },
        {
          value:24,
          label:24
        },
        {
          value:25,
          label:25
        },
        {
          value:26,
          label:26
        },
        {
          value:27,
          label:27
        },
        {
          value:28,
          label:28
        },
        {
          value:29,
          label:29
        },
        {
          value:30,
          label:30
        },
        {
          value:31,
          label:31
        },
        {
          value:32,
          label:32
        }
      ],
      devControl:"devControl",
      my_treeCtr:"my_treeCtr",
      li_head:"li_head",
      my_main:"my_main",
      man_li:"man_li",
      head_liman:"head_liman",
      grid_box:"grid_box",
      grid_item:"grid_item",
      bj_daiLog:"data-dialog",
      bj_table:"bj_table",
      bj_but:"#409EFF",
      bj_but_color:"#FFFFFF",
      bj_but_1:"#283A4D",
      bj_tab:"#283A4D",
      bj_tab_color:"#FFFFFF",
      fil_mac:[
        "0100000004",
        "0100000005",
        "0100000006",
        "0100000007",
        "0100000008",
        "0100000009",
        "010000000a",
        "010000000b",
        "010000000c",
        "010000000d"
      ]
    };
  },
  methods:{
    renderContent(h,{node,data,store}) {
      // <el-button size="mini" type="text" on-click={() => this.append(data)}>Append</el-button>
      return (
        <span style="display:flex;width:100%;">
            <span style="flex:1">{node.label}</span>
            <span style="margin-left:auto;margin-right:10px;">
              <el-dropdown ref="dropdown"
                           style="float:right; margin-left:6px; font-size: 15px">
                <span style="padding-top:3px">
                  <i v-show={data['id1'] === this.xz_id && data['locate'] === this.xz_area && data['locate'] !== 'dev'}
                     class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                   <div class="hoverElement" v-show={data['locate'] !== 'room'}
                        style="text-align: center;width:80px;height:30px;margin-top:6px;padding-top:6px">
                     <el-button size="mini" type="text"
                                on-click={() => this.addArea(data)}>{this.$t('添加区域')}</el-button>
                   </div>
                   <div class="hoverElement" v-show={this.xz_id !== -1}
                        style="text-align: center;width:80px;height: 30px;margin-top:6px;padding-top:6px">
                     <el-button size="mini" type="text"
                                on-click={() => this.changeArea(data)}>{this.$t('修改信息')}</el-button>
                   </div>
                   <div class="hoverElement" v-show={this.xz_id !== -1}
                        style="text-align: center;width:80px;height: 30px;margin-top:6px;padding-top:6px">
                     <el-button size="mini" type="text"
                                on-click={() => this.delArea(data)}>{this.$t('删除区域')}</el-button>
                   </div>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </span>
      );
    },
    addTopic(newTopic) {
      if (!this.topics.includes(newTopic)) {
        this.client.subscribe(newTopic,{qos:1},(err) => {
          if (!err) {
            this.topics.push(newTopic);
            console.log('动态订阅:',newTopic);
          }
        });
      }
    },

    // 动态取消订阅
    removeTopic(topic) {
      this.client.unsubscribe(topic,(err) => {
        if (!err) {
          this.topics = this.topics.filter(t => t !== topic);
          this.$delete(this.messages,topic);
          console.log('已取消订阅:',topic);
        }
      });
    },
    unsubscribeAll(callback) {
      if (!this.client || !this.client.connected || this.topics.size === 0) {
        callback && callback();
        return;
      }

      const topics = Array.from(this.topics);
      let completed = 0;

      topics.forEach(topic => {
        this.client.unsubscribe(topic,(err) => {
          if (err) console.error('取消订阅失败:',topic,err);
          else console.log('已取消订阅:',topic);

          const index = this.topics.indexOf(topic);
          if (index !== -1) {
            this.topics.splice(index,1);
          }
          completed++;

          // 全部完成后执行回调
          if (completed === topics.length) {
            callback && callback();
          }
        });
      });
    },
    addArea(data) {
      this.txt_name = this.$t("区域名称：");
      this.txt_title = this.$t("添加区域");
      this.dai_area = true;
    },
    changeArea(data) {
      this.txt_name = this.$t("区域名称：");
      this.txt_title = this.$t("修改区域");
      this.dai_area = true;
    },
    delArea(data) {
      this.delTip = this.$t("您确定要删除此区域吗？");
      this.dialogVisible = true;
    },
    keep_area() {
      if (this.txt_title === this.$t("修改区域")) {
        let params = {
          'kt_token':localStorage.getItem('token'),
          'kt_dwid':localStorage.getItem('did'),
          'kt_sonid':localStorage.getItem('kt_sonid')
        };
        let url = this.$urls.ip;
        switch (this.xz_area) {
          case "area":
            params["area_id"] = this.xz_id;
            params["area_name"] = this.edi_name;
            params["area_bz"] = "";
            url = this.$urls.ip + this.$urls.change_area;
            break;
          case "building":
            params["building_id"] = this.xz_id;
            params["building_name"] = this.edi_name;
            params["building_bz"] = "";
            url = this.$urls.ip + this.$urls.change_building;
            break;
          case "unit":
            params["unit_id"] = this.xz_id;
            params["unit_name"] = this.edi_name;
            params["unit_bz"] = "";
            url = this.$urls.ip + this.$urls.change_unit;
            break;
          case "floor":
            params["floor_id"] = this.xz_id;
            params["floor_name"] = this.edi_name;
            params["floor_bz"] = "";
            url = this.$urls.ip + this.$urls.change_floor;
            break;
          case "room":
            params["room_id"] = this.xz_id;
            params["room_name"] = this.edi_name;
            params["room_bz"] = "";
            url = this.$urls.ip + this.$urls.change_room;
            break;
        }
        console.log(params);
        this.$api.post(url,params).then(res => {
          console.log(res.data);
          this.$message.success(this.$t("修改成功"));
          this.dai_area = false;
          this.get_area_list();
          switch (this.xz_area) {
            case 'area':
              this.get_area();
              break;
            case 'building':
              this.get_building();
              break;
            case 'unit':
              this.get_unit();
              break;
            case 'floor':
              this.get_floor();
              break;
            case 'room':
              this.get_room();
              break;
          }
        }).catch(error => {
          this.loading.close();
          this.dai_area = false;
          this.$message.error(this.$t("修改失败"));
        });
      } else {
        let params = {
          'kt_token':localStorage.getItem('token'),
          'kt_dwid':localStorage.getItem('did'),
          'kt_sonid':localStorage.getItem('kt_sonid')
        };
        let url = this.$urls.ip;
        switch (this.xz_area) {
          case "all":
            switch (this.area_max) {
              case 'floor':
                params["kt_unit"] = this.maxArea_id;
                params["floor_name"] = this.edi_name;
                params["floor_bz"] = "";
                url = this.$urls.ip + this.$urls.add_floor;
                break;
              case 'unit':
                params["building_id"] = this.maxArea_id;
                params["unit_name"] = this.edi_name;
                params["unit_bz"] = "";
                url = this.$urls.ip + this.$urls.add_unit;
                break;
              case 'building':
                params["area_id"] = this.maxArea_id;
                params["building_name"] = this.edi_name;
                params["building_bz"] = "";
                url = this.$urls.ip + this.$urls.add_building;
                break;
              case 'area':
                params["area_name"] = this.edi_name;
                params["area_bz"] = "";
                url = this.$urls.ip + this.$urls.add_area;
                break;
            }
            break;
          case "area":
            params["area_id"] = this.xz_id;
            params["building_name"] = this.edi_name;
            params["building_bz"] = "";
            url = this.$urls.ip + this.$urls.add_building;
            break;
          case "building":
            params["building_id"] = this.xz_id;
            params["unit_name"] = this.edi_name;
            params["unit_bz"] = "";
            url = this.$urls.ip + this.$urls.add_unit;
            break;
          case "unit":
            params["kt_unit"] = this.xz_id;
            params["floor_name"] = this.edi_name;
            params["floor_bz"] = "";
            url = this.$urls.ip + this.$urls.add_floor;
            break;
          case "floor":
            params["floor_id"] = this.xz_id;
            params["room_name"] = this.edi_name;
            params["room_bz"] = "";
            url = this.$urls.ip + this.$urls.add_room;
            break;
        }
        console.log(params);
        this.$api.post(url,params).then(res => {
          console.log(res.data);
          this.$message.success(this.$t("添加成功"));
          this.dai_area = false;
          this.get_area_list();
          switch (this.xz_area) {
            case "all":
              switch (this.area_max) {
                case 'floor':
                  this.get_floor();
                  break;
                case 'unit':
                  this.get_unit();
                  break;
                case 'building':
                  this.get_building();
                  break;
                case 'area':
                  this.get_area();
                  break;
              }
              break;
            case 'area':
              this.get_building();
              break;
            case 'building':
              this.get_unit();
              break;
            case 'unit':
              this.get_floor();
              break;
            case 'floor':
              this.get_room();
              break;
          }
        }).catch(error => {
          this.loading.close();
          this.dai_area = false;
          this.$message.error(this.$t("添加失败"));
        });
      }
    },
    del_area() {
      this.loading = this.$loading({spinner:"",text:this.$t("正在加载中..."),background:"rgba(0, 0, 0, 0.3)"});
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid')
      };
      let url = this.$urls.ip;
      switch (this.xz_area) {
        case "area":
          params["area_id"] = this.xz_id;
          url = this.$urls.ip + this.$urls.del_area;
          break;
        case "building":
          params["building_id"] = this.xz_id;
          url = this.$urls.ip + this.$urls.del_building;
          break;
        case "unit":
          params["unit_id"] = this.xz_id;
          url = this.$urls.ip + this.$urls.del_unit;
          break;
        case "floor":
          params["floor_id"] = this.xz_id;
          url = this.$urls.ip + this.$urls.del_floor;
          break;
        case "room":
          params["room_id"] = this.xz_id;
          url = this.$urls.ip + this.$urls.del_room;
          break;
      }
      console.log(params);
      this.$api.post(url,params).then(res => {
        this.loading.close();
        console.log(res.data);
        this.$message.success(this.$t("删除成功"));
        this.dialogVisible = false;
        this.isOne = true;
        this.defKey = [-1];
        this.get_area_list();
        switch (this.xz_area) {
          case 'area':
            this.get_area();
            break;
          case 'building':
            this.get_building();
            break;
          case 'unit':
            this.get_unit();
            break;
          case 'floor':
            this.get_floor();
            break;
          case 'room':
            this.get_room();
            break;
        }
      }).catch(error => {
        this.loading.close();
        this.dialogVisible = false;
        this.$message.error(this.$t("删除失败"));
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getDevData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getDevData();
    },
    devSx() {
      this.page = 1;
      this.getDevData();
    },
    show_change1(item) {
      if (item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item) {
      if (item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    on_name(row) { /*修改名称弹窗*/
      this.isUpdate = false;
      console.log(row);
      this.edi_dev_type = row.pid;
      this.d_id = row.id;
      this.dev_name = row.dev_name;
      this.d_qid = row.wg_qid;
      this.edi_area = row.area_id;
      this.edi_building = row.building_id;
      this.edi_unit = row.unit_id;
      this.edi_floor = row.floor_id;
      this.edi_room = row.room_id;
      this.dev_id = row.dev_id;
      this.dev_bz = row.dev_bz;
      this.mac_list = [{value:row.wg_id,label:row.mac}];
      this.edi_mac = row.wg_id;
      this.dailogchange = true;
    },
    area_xz() {
      console.log(this.edi_area);
      let l = [];
      for (let i = 0; i < this.building_data.length; i++) {
        let d = {
          value:this.building_data[i]['building_id'],
          label:this.building_data[i]['building_name']
        };
        console.log(this.building_data[i]);
        if (this.edi_area === this.building_data[i]['area_id']) {
          l.push(d);
        }
      }
      this.building_list = l;
      let d = this.building_list.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        return fruit['building_id'] === this.edi_building;
      });
      if (d === undefined && this.building_list.length > 0) {
        this.edi_building = this.building_list[0]['value'];
      } else {
        this.edi_building = "";
      }
      this.building_xz();
    },
    building_xz() {
      console.log(this.edi_building);
      let l = [];
      for (let i = 0; i < this.unit_data.length; i++) {
        let d = {
          value:this.unit_data[i]['unit_id'],
          label:this.unit_data[i]['unit_name']
        };
        console.log(this.unit_data[i]);
        if (this.edi_building === this.unit_data[i]['building_id']) {
          l.push(d);
        }
      }
      this.unit_list = l;
      let d = this.unit_list.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        return fruit['unit_id'] === this.edi_unit;
      });
      if (d === undefined && this.unit_list.length > 0) {
        this.edi_unit = this.unit_list[0]['value'];
      } else {
        this.edi_unit = "";
      }
      this.unit_xz();
    },
    unit_xz() {
      this.edi_floor = "";
      this.edi_room = "";
    },
    floor_xz() {
      this.edi_room = "";
    },
    handleNodeClick(data) { /*区域点击事件*/
      console.log(data['id1'],data['locate'],data['label']);
      this.defKey = [data['id']];
      this.xz_id = data['id1'];
      this.xz_area = data['locate'];
      this.page = 1;
      this.getDevData();
    },
    upDate() { /*更新时间*/
      console.log("弹出加载框");
      this.loading = this.$loading({spinner:"",text:this.$t("正在加载中..."),background:"rgba(0, 0, 0, 0.3)"});
      this.getLs_Data();
    },
    getAllDate(start,end) { /*获取两个时间中间所有时间*/
      var dateList = [];
      var startTime = Date.parse(new Date(start));
      var endTime = Date.parse(new Date(end));
      var days = Math.ceil((endTime - startTime) / (1000 * 60 * 60 * 24));
      for (var i = 0; i < days; i++) {
        var tempDate = new Date(startTime + i * 24 * 60 * 60 * 1000);
        dateList.push({
          "key":this.formatDateTime(tempDate,'allDate'),
          "val":this.formatDateTime(tempDate,'day') + " 00:00:00"
        });
      }
      dateList.push({ /*添加结束日期*/
        "key":this.formatDateTime(new Date(end),'allDate'),
        "val":this.formatDateTime(new Date(end),'day') + " 00:00:00"
      });
      return dateList;
    },
    getYesterday() { /*获取昨天时间*/
      return [
        new Date(moment().subtract(1,'day').format('YYYY-MM-DD')),
        new Date(moment().subtract(-1,'day').format('YYYY-MM-DD'))
      ];
      // let isDate = new Date()
      // if (isDate.getDate() === 1) {
      //   let sTime = `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate()}`
      //   let eTime = `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate()}`
      //   return [new Date(sTime), new Date(eTime)]
      // } else {
      //   let sTime = `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate() - 1}`
      //   let eTime = `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate() - 1}`
      //   return [new Date(sTime), new Date(eTime)]
      // }
    },
    pad(num) {
      return num.toString().padStart(2,'0');
    },
    formatDateTime(date,name) { /*时间解析*/
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      let data = "";
      switch (name) {
        case "allDate":
          data = `${this.pad(month)}/${this.pad(day)}`;
          break;
        case "day":
          data = `${year}-${this.pad(month)}-${this.pad(day)}`;
          break;
      }
      return data;
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      if (this.bj === '1') {
        return 'text-align:center;background:#FFFFFF;color:#000000';
      } else {
        return 'text-align:center;background:#283A4D;color:#ffffff';
      }
    },
    getLs_Data() {
      let id1 = this.sites.findIndex((index) => { /*js快速查找数组索引*/
        if (index['id'] === this.roomid) {
          return true;
        }
      });
      if (id1 !== -1) {
        let params = {
          'kt_token':localStorage.getItem('token'),
          'kt_dwid':localStorage.getItem('did'),
          'kt_sonid':localStorage.getItem('kt_sonid'),
          'start_time':this.formatDateTime(this.xz_date[0],'day'),
          'end_time':this.formatDateTime(this.xz_date[1],'day'),
          'wg_mac':this.sites[id1]['mac'],
          'wg_qid':this.sites[id1]['wg_qid'],
          'page':1,
          'pageSize':100000
        };
        console.log(params);
        this.$api.get(this.$urls.ip + this.$urls.get_log_one_dev,params).then(res => {
          let ls_data = res.data['data'];
          this.loading.close();
          console.log("拿到历史数据");
          console.log(ls_data);
          let l_data = [];
          for (let i = 0; i < ls_data.length; i++) {
            let d_data = {};
            d_data['uptime'] = ls_data[i]['uptime'];
            d_data['ctr_type'] = ls_data[i]['ctr_type'];
            d_data['set_type'] = ls_data[i]['set_type'];
            d_data['set_val'] = ls_data[i]['set_val'];
            d_data['res'] = ls_data[i]['res'];
            if (d_data['res'] === "1") {
              d_data['res'] = this.$t("控制成功");
            } else {
              d_data['res'] = this.$t("控制失败");
            }
            l_data.push(d_data);
          }
          this.tableData = l_data.sort((a,b) => {
            return new Date(b.uptime) - new Date(a.uptime);
          });
        }).catch(error => {
          this.loading.close();
          this.$message.error(this.$t("获取报表数据失败，请点击左上角刷新按钮"));
        });
      }
    },
    threeHand(roomData) { /*家庭列表数据*/
      let usrName = localStorage.getItem('gs_name');
      // let usrName = localStorage.getItem('unit_name')
      let floorL = [{id:-1,name:'all',label:usrName,children:[]}];
      console.log(this.lc_list);
      for (let i = 0; i < this.ld_list.length; i++) {
        let l_d = {
          id:this.ld_list[i]["floor_id"],name:'lou',v:0,flou:"",fceng:"",label:this.ld_list[i]["floor_name"],
          children:[],louid:this.ld_list[i]["floor_id"]
        };
        floorL[0].children.push(l_d);
      }
      floorL[0].children = this.bubbleSort(floorL[0].children,'label'); /*楼层排序*/
      this.lc_list = this.bubbleSort(this.lc_list,'room_name');  /*房间排序*/
      for (let i = 0; i < this.lc_list.length; i++) {
        let int_l = floorL[0].children.findIndex((fruit) => { /*js快速查找数组*/
          return fruit['id'] === this.lc_list[i]["floor_id"];
        });
        if (int_l !== -1) {
          let d_ceng = {
            id:this.lc_list[i]["room_id"],name:'ceng',v:0,flou:floorL[0].children[int_l].label,fceng:"",
            label:this.lc_list[i]["room_name"],children:[],cengid:this.lc_list[i]["room_id"]
          };
          floorL[0].children[int_l].children.push(d_ceng);
        }
      }
      roomData = this.bubbleSort(roomData,'dev_name');  /*房间排序*/
      for (let i = 0; i < roomData.length; i++) {
        let int_l = floorL[0].children.findIndex((fruit) => {
          return fruit['id'] === roomData[i]["floor_id"];
        });
        if (int_l !== -1) {
          let int_lc = floorL[0].children[int_l].children.findIndex((fruit) => {
            return fruit['cengid'] === roomData[i]["room_id"];
          });
          if (int_lc !== -1) {
            let d_jian = {
              id:roomData[i]["dev_id"],
              name:'jian',
              v:0,
              flou:roomData[i]["floor_name"],
              fceng:roomData[i]["room_name"],
              label:roomData[i]["dev_name"],
              children:[]
            };
            floorL[0].children[int_l].children[int_lc].children.push(d_jian);
          }
        }
      }
      this.treeData = floorL;
      // let l_d = { /*增加所有主机控制*/
      //   id: -1, name: 'zj', v: 0, flou: "", fceng: "", label: "主机控制",
      //   children: [], louid: -1,
      // }
      // this.treeData[0].children.push(l_d)
    },
    threeHand1(roomData) { /*家庭列表数据*/
      console.log(roomData);
      let usrName = localStorage.getItem('gs_name');
      let floorL = [{id:-1,name:'all',label:usrName,children:[]}];
      for (var i = 0; i < roomData.length; i++) { /*获取所有楼层数据*/
        if (floorL[0].children.some(item => item['louid'] === roomData[i]["kt_louid"]) !== true) {
          let d_lou = {
            id:roomData[i]["id"],name:'lou',v:0,flou:"",fceng:"",label:roomData[i]["floor_name"],
            children:[],louid:roomData[i]["kt_louid"]
          };
          d_lou['v'] = floorL[0].children.length;
          floorL[0].children.push(d_lou);
        } /*添加房间数据*/
        floorL[0].children = this.bubbleSort(floorL[0].children,'label'); /*楼层排序*/
        let int_l = floorL[0].children.find((fruit) => { /*js快速查找数组*/
          return fruit['label'] === roomData[i]["floor_name"];
        });
        if (floorL[0].children[int_l['v']].children.some(item => item['cengid'] === roomData[i]["kt_cengid"]) !== true) {
          let d_ceng = {
            id:roomData[i]["id"],name:'ceng',v:0,flou:roomData[i]["floor_name"],fceng:"",
            label:roomData[i]["room_name"],children:[],cengid:roomData[i]["kt_cengid"]
          };
          d_ceng['v'] = floorL[0].children[int_l['v']].children.length;
          floorL[0].children[int_l['v']].children.push(d_ceng);
        } /*添加房间数据*/
        let int_c = floorL[0].children[int_l['v']].children.find((fruit) => { /*js快速查找数组*/
          return fruit['cengid'] === roomData[i]["kt_cengid"];
        });
        let d_jian = {
          id:roomData[i]["id"],name:'jian',v:0,flou:roomData[i]["floor_name"],fceng:roomData[i]["room_name"],
          label:roomData[i]["dev_name"],children:[]
        };
        d_jian['v'] = floorL[0].children[int_l['v']].children[int_c['v']].children.length;
        let l_jian = floorL[0].children[int_l['v']].children[int_c['v']].children;
        if (l_jian.findIndex((index) => { /*js快速查找数组索引，没找到返回-1*/
          return index['label'] === roomData[i]["dev_name"];
        }) === -1) {
          floorL[0].children[int_l['v']].children[int_c['v']].children.push(d_jian); /*过滤相同名称房间*/
        }
      }
      this.treeData = floorL;
      // let l_chen = l_chen.filter(item => item['floor_name'] === li_lou[i]); /*js查找数据返回数组*/
    },
    threeHand3() { /*家庭列表数据*/
      let gsName = localStorage.getItem('gs_name');
      let li_area = [{id:-1,id1:-1,locate:'all',label:gsName,children:[]}];
      if (this.isOne) {
        this.xz_id = -1;
        this.xz_area = 'all';
      }
      this.isOne = false;
      for (let i = 0; i < this.area_list1.length; i++) {
        li_area[0]["children"].push({
          id:i,
          id1:this.area_list1[i]["id"],
          label:this.area_list1[i]["name"],
          locate:this.area_list1[i]["locate"],
          children:[]
        });
        let l1 = this.area_list1[i]["child"];
        for (let j = 0; j < l1.length; j++) {
          li_area[0]["children"][i]["children"].push({
            id:(i + 1) * 100 + j,
            id1:l1[j]["id"],
            label:l1[j]["name"],
            locate:l1[j]["locate"],
            children:[]
          });
          let l2 = l1[j]["child"];
          for (let j2 = 0; j2 < l2.length; j2++) {
            li_area[0]["children"][i]["children"][j]["children"].push({
              id:(i + 1) * 1000 + j * 100 + j2,
              id1:l2[j2]["id"],
              label:l2[j2]["name"],
              locate:l2[j2]["locate"],
              children:[]
            });
            let l3 = l2[j2]["child"];
            for (let j3 = 0; j3 < l3.length; j3++) {
              li_area[0]["children"][i]["children"][j]["children"][j2]["children"].push({
                id:(i + 1) * 10000 + j * 1000 + j2 * 100 + j3,
                id1:l3[j3]["id"],
                label:l3[j3]["name"],
                locate:l3[j3]["locate"],
                children:[]
              });
              let l4 = l3[j3]["child"];
              for (let j4 = 0; j4 < l4.length; j4++) {
                li_area[0]["children"][i]["children"][j]["children"][j2]["children"][j3]["children"].push({
                  id:(i + 1) * 100000 + j * 10000 + j2 * 1000 + j3 * 100 + j4,
                  id1:l4[j4]["id"],
                  label:l4[j4]["name"],
                  locate:l4[j4]["locate"],
                  children:[]
                });
                let l5 = l4[j4]["child"];
                for (let j5 = 0; j5 < l5.length; j5++) {
                  li_area[0]["children"][i]["children"][j]["children"][j2]["children"][j3]["children"][j4]["children"].push({
                    id:(i + 1) * 1000000 + j * 100000 + j2 * 10000 + j3 * 1000 + j4 * 100 + j5,
                    id1:l5[j5]["id"],
                    label:l5[j5]["name"],
                    locate:l5[j5]["locate"],
                    children:[]
                  });
                }
                li_area[0]["children"][i]["children"][j]["children"][j2]["children"][j3]["children"][j4]["children"] = this.bubbleSort(li_area[0]["children"][i]["children"][j]["children"][j2]["children"][j3]["children"][j4]["children"],"label");
              }
              li_area[0]["children"][i]["children"][j]["children"][j2]["children"][j3]["children"] = this.bubbleSort(li_area[0]["children"][i]["children"][j]["children"][j2]["children"][j3]["children"],"label");
            }
            li_area[0]["children"][i]["children"][j]["children"][j2]["children"] = this.bubbleSort(li_area[0]["children"][i]["children"][j]["children"][j2]["children"],"label");
          }
          li_area[0]["children"][i]["children"][j]["children"] = this.bubbleSort(li_area[0]["children"][i]["children"][j]["children"],"label");
        }
        li_area[0]["children"][i]["children"] = this.bubbleSort(li_area[0]["children"][i]["children"],"label");
      }
      li_area[0]["children"] = this.bubbleSort(li_area[0]["children"],"label");
      this.treeData = li_area;
      // let l_d = { /*增加所有主机控制*/
      //   id: -1, name: 'zj', v: 0, flou: "", fceng: "", label: "主机控制",
      //   children: [], louid: -1,
      // }
      // this.treeData[0].children.push(l_d)
    },
    dialog_Change(v) { /*修改设备名称*/
      this.isUpdate = true;
      switch (v) {
        case "保存":
          if (this.edi_mac === null || this.edi_mac.length < 1) {
            this.$message.error(this.$t('请先选择所属网关'));
          } else if (this.edi_unit === null || this.edi_unit.length < 1) {
            this.$message.error(this.$t('请先选择所属楼栋'));
          } else if (this.edi_floor === null || this.edi_floor.length < 1) {
            this.$message.error(this.$t('请先选择所属楼层'));
          } else if (this.edi_room === null || this.edi_room.length < 1) {
            this.$message.error(this.$t('请先选择所属房间'));
          } else if (this.dev_name === null || this.dev_name.length < 1) {
            this.$message.error(this.$t('请先输入设备名称'));
          } else {
            if (this.d_qid === null || this.d_qid.length === 0) {
              this.$message.error(this.$t('请先输入空调内机编号'));
            } else {
              this.change_db();
            }
          }
          break;
        case "退出":
          clearTimeout(this.timer_wd);  //按钮高亮3毫秒变回
          this.timer_wd = setTimeout(() => {
            this.dailog_qxbg = this.bj_but_1;
          },300);
          this.dailogchange = false; /*将dialog关闭*/
          break;
      }
    },
    change_db() {
      this.loading = this.$loading({spinner:"",text:this.$t("正在加载中..."),background:"rgba(0, 0, 0, 0.3)"});
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        "pid":this.edi_dev_type,
        "floor_id":this.edi_floor,
        "room_id":this.edi_room,
        "dev_id":this.dev_id,
        "dev_name":this.dev_name,
        "wg_id":this.edi_mac,
        "wg_qid":this.d_qid,
        "dev_bz":this.dev_bz
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.change_dev,params).then(res => {
        let li_temp = res.data;
        this.$message.success(this.$t("修改成功"));
        this.changeName = true;
        this.getDevData();
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("修改设备信息失败"));
      });
      this.dailogchange = false;
      this.loading.close();
    },
    dialog_Onclick(name) { /*锁定*/
      switch (name) {
        case "锁定": {
          let id = this.dailog_xzVlue;
          if (!this.isLockEnabled(this.sites[id]['pid'])) {
            this.$message.warning(this.$t("该设备类型不支持锁定功能"));
            this.dailogShow = false;
            return;
          }
        }
          this.dailog_qdbg = '#409EFF';
          clearTimeout(this.timer_wd);  // 按钮高亮延时变回颜色
          this.timer_wd = setTimeout(() => {
            this.dailog_qdbg = this.bj_but_1;
          },300);
          let params = { /*锁定接口要发送的参数*/
            'kt_token':localStorage.getItem('token'),
            'kt_dwid':localStorage.getItem('did'),
            'kt_sonid':localStorage.getItem('kt_sonid')
          };
          let id = this.dailog_xzVlue;
          params['wg_mac'] = this.sites[id]['mac'];
          params['wg_qid'] = this.sites[id]['qid'];
          params['pid'] = this.sites[id]['pid'];
          params['set_type'] = "lock_many";
          params['set_val'] = this.getDialog_value(id);
          if (this.sites[id]['online'] === 88) {
            this.setData(params,true);
            this.isUpdate = false; /*停止更新数据*/
            this.sites[id]['bg_sd'] = this.bj_but;
            this.sites[id]['kt_lock'] = 1;
            this.dailogShow = false; /*关闭dialog弹框*/
            this.checkAll = false; /*取消全选框*/
          }
          break;
        case "退出":
          this.dailog_qxbg = this.bj_but;
          clearTimeout(this.timer_wd);  //按钮高亮3毫秒变回
          this.timer_wd = setTimeout(() => {
            this.dailog_qxbg = this.bj_but_1;
          },300);
          this.isUpdate = true; /*继续更新数据*/
          this.dailogShow = false; /*将dialog关闭*/
          break;
      }
      clearTimeout(this.timer_kz);  //清除延迟更新状态
      this.timer_kz = setTimeout(() => {   //设置延迟执行
        this.isUpdate = true; /*继续更新数据*/
      },36000);
    },
    dialog_sj_sd(type) {
      {
        let checkId = this.dailog_xzVlue;
        if (checkId !== -1 && !this.isLockEnabled(this.sites[checkId]['pid'])) {
          this.$message.warning(this.$t("该设备类型不支持锁定功能"));
          this.dailogShow = false;
          return;
        }
      }
      if (type === "开关") {
        let params = { /*锁定接口要发送的参数*/
          'kt_token':localStorage.getItem('token'),
          'kt_dwid':localStorage.getItem('did')
        };
        let detail = -1;
        if (this.dailog_xzVlue === -1) {
          let loading = this.$loading({spinner:"",text:this.$t("发送数据中..."),background:"rgba(0, 0, 0, 0.3)"});
          for (var i = 0; i < this.sites.length; i++) { /*遍历选择框*/
            let id = i;
            if (this.sites[id]['check']) {
              params['wg_mac'] = this.sites[id]['mac'];
              params['wg_qid'] = this.sites[id]['qid'];
              params['pid'] = this.sites[id]['pid'];
              detail = this.getDialog_sj_value(type,id);
              params['set_type'] = "lock";
              params['set_val'] = 2;
              console.log(params);
              if (this.sites[id]['online'] === 88) {
                if (detail !== -1) {
                  params['setdetail'] = "1,0,0,0,0,0";
                  this.setData(params,false);
                  this.isUpdate = false; /*停止更新数据*/
                  this.sites[id]['bg_sd'] = this.bj_but;
                  this.sites[id]['kt_lock'] = 1;
                } else {
                  params['set_val'] = 0;
                  // params['setdetail'] = "-1,0,0,0,0,0"
                  this.setData(params,false);
                  this.isUpdate = false; /*停止更新数据*/
                  this.sites[id]['bg_sd'] = this.bj_but_1;
                  this.sites[id]['kt_lock'] = 0;
                }
              }
              this.sites[id]['check'] = false;
            }
          }
          // 设置锁定后统一控制开关
          // params['set_type'] = 2
          // params['set_val'] = detail
          // if (detail !== -1) {
          //   setTimeout(() => {   //设置延迟执行
          //     for (var i = 0; i < this.sites.length; i++) {
          //       let id = i
          //       params['wg_mac'] = this.sites[id]['mac']
          //       params['wg_qid'] = this.sites[id]['qid']
          //       this.setData(params, false)
          //     }
          //   }, 5000);
          // }
          loading.close();
        } else { /*单台控制*/
          let id = this.dailog_xzVlue;
          detail = -1;
          params['wg_mac'] = this.sites[id]['mac'];
          params['wg_qid'] = this.sites[id]['qid'];
          params['pid'] = this.sites[id]['pid'];
          detail = this.getDialog_sj_value(type,id);
          params['set_type'] = "lock";
          params['set_val'] = this.getDialog_sj_value(type,id);
          console.log(params);
          if (this.sites[id]['online'] === 88) {
            if (detail !== -1) {
              params['setdetail'] = "1,0,0,0,0,0";
              this.setData(params,false);
              this.isUpdate = false; /*停止更新数据*/
              this.sites[id]['bg_sd'] = this.bj_but;
              this.sites[id]['kt_lock'] = 1;
            } else {
              params['set_val'] = 0;
              // params['setdetail'] = "-1,0,0,0,0,0"
              this.setData(params,false);
              this.isUpdate = false; /*停止更新数据*/
              this.sites[id]['bg_sd'] = this.bj_but_1;
              this.sites[id]['kt_lock'] = 0;
            }
            // setTimeout(() => {   //设置延迟执行
            //   params['set_type'] = 2
            //   params['set_val'] = detail
            //   this.setData(params, false)
            // }, 3000);
          }
        }
        this.dailogShow = false; /*关闭dialog弹框*/
        this.checkAll = false; /*取消全选框*/
        this.$message.success(this.$t("锁定成功"));
        clearTimeout(this.timer_kz);  //清除延迟更新状态
        this.timer_kz = setTimeout(() => {//设置延迟执行
          this.isUpdate = true; /*继续更新数据*/
        },36000);
      }
      if (type === "温度") {
        let params = { /*锁定接口要发送的参数*/
          'kt_token':localStorage.getItem('token'),
          'kt_dwid':localStorage.getItem('did')
        };
        if (this.dailog_xzVlue === -1) {
          let loading = this.$loading({spinner:"",text:this.$t("发送数据中..."),background:"rgba(0, 0, 0, 0.3)"});
          for (var i = 0; i < this.sites.length; i++) { /*遍历选择框*/
            let id = i;
            if (this.sites[id]['check']) {
              params['wg_mac'] = this.sites[id]['mac'];
              params['wg_qid'] = this.sites[id]['qid'];
              params['pid'] = this.sites[id]['pid'];
              params['setdetail'] = this.getDialog_sj_value(type,id);
              params['set_type'] = 19;
              params['set_val'] = 1;
              console.log(params);
              if (this.sites[id]['online'] === 88) {
                this.setData(params,false);
                this.isUpdate = false; /*停止更新数据*/
              }
              this.sites[id]['check'] = false;
            }
          }
          loading.close();
          this.dailogShow = false; /*关闭dialog弹框*/
          this.checkAll = false; /*取消全选框*/
          this.$message.success(this.$t("锁定成功"));
          clearTimeout(this.timer_kz);  //清除延迟更新状态
          this.timer_kz = setTimeout(() => {//设置延迟执行
            this.isUpdate = true; /*继续更新数据*/
          },36000);
        } else {
          let id = this.dailog_xzVlue;
          params['wg_mac'] = this.sites[id]['mac'];
          params['wg_qid'] = this.sites[id]['qid'];
          params['pid'] = this.sites[id]['pid'];
          params['set_type'] = "lock_temp";
          params['set_val'] = {
            "cold_min":parseInt(this.sj_xz_temp_min) * 10,
            "cold_max":parseInt(this.sj_xz_temp_max) * 10,
            "heat_min":parseInt(this.sj_xz_temp_min1) * 10,
            "heat_max":parseInt(this.sj_xz_temp_max1) * 10
          };
          // params['setdetail'] = this.getDialog_sj_value(type, id)
          console.log(params);
          if (this.sites[id]['online'] === 88) {
            this.setData(params,true);
            this.isUpdate = false; /*停止更新数据*/
            this.dailogShow = false; /*关闭dialog弹框*/
            this.checkAll = false; /*取消全选框*/
            clearTimeout(this.timer_kz);  //清除延迟更新状态
          }
        }
        this.timer_kz = setTimeout(() => {   //设置延迟执行
          this.isUpdate = true; /*继续更新数据*/
        },36000);
      }
    },
    getDialog_sj_value(type,id) { /*获取水机dialog锁定内容*/
      let setdetail = "";
      if (type === "开关") {
        const lockCfg = this.pidLockMap[this.sites[id]['pid']] || this.pidLockMap['default'];
        const lockList = (lockCfg && lockCfg.lockList) || [
          {value:3,label:'全锁'},
          {value:1,label:'半锁'},
          {value:0,label:'解锁'}
        ];
        const fullLock = lockList.find(l => l.label === '全锁');
        const halfLock = lockList.find(l => l.label === '半锁');
        const unlockLock = lockList.find(l => l.label === '解锁');
        switch (this.sj_sd_kg) {
          case "全锁":
            setdetail = fullLock ? fullLock.value:3;
            this.sites[id]['bg_dy'] = this.bj_but;
            // this.sites[id]['pwr'] = 1
            break;
          case "半锁":
            setdetail = halfLock ? halfLock.value:1;
            this.sites[id]['bg_dy'] = this.bj_but_1;
            // this.sites[id]['pwr'] = 0
            break;
          default:
            setdetail = unlockLock ? unlockLock.value:0;
            break;
        }
      } else {
        setdetail += parseInt(this.sj_xz_temp_min1) * 10 + ',';
        setdetail += parseInt(this.sj_xz_temp_max1) * 10 + ',';
        setdetail += parseInt(this.sj_xz_temp_min) * 10 + ',';
        setdetail += parseInt(this.sj_xz_temp_max) * 10 + ',';
      }
      return setdetail;
    },
    getDialog_value(id) { /*获取dialog锁定内容*/
      let setdetail = {"lock_pwr":1};
      switch (this.xz_kg) {
        case "开机":
          setdetail['pwr'] = 1;
          this.sites[id]['bg_dy'] = this.bj_but;
          this.sites[id]['pwr'] = 1;
          break;
        case "关机":
          setdetail['pwr'] = 0;
          this.sites[id]['bg_dy'] = this.bj_but_1;
          this.sites[id]['pwr'] = 0;
          break;
        default:
          setdetail['pwr'] = -1;
          break;
      }
      const modeValue = this.getModeValueByLabel(this.sites[id]['pid'],this.xz_mode);
      setdetail['mode'] = modeValue;
      switch (this.xz_mode) {
        case "制热":
          this.sites[id]['icon_mode_re'] = 'mode_re_1';
          this.sites[id]['icon_mode_len'] = 'mode_len_0';
          this.sites[id]['icon_mode_sf'] = 'mode_sf_0';
          this.sites[id]['icon_mode_cs'] = 'mode_cs_0';
          break;
        case "制冷":
          this.sites[id]['icon_mode_re'] = 'mode_re_0';
          this.sites[id]['icon_mode_len'] = 'mode_len_1';
          this.sites[id]['icon_mode_sf'] = 'mode_sf_0';
          this.sites[id]['icon_mode_cs'] = 'mode_cs_0';
          break;
        case "送风":
          this.sites[id]['icon_mode_re'] = 'mode_re_0';
          this.sites[id]['icon_mode_len'] = 'mode_len_0';
          this.sites[id]['icon_mode_sf'] = 'mode_sf_1';
          this.sites[id]['icon_mode_cs'] = 'mode_cs_0';
          break;
        case "除湿":
          this.sites[id]['icon_mode_re'] = 'mode_re_0';
          this.sites[id]['icon_mode_len'] = 'mode_len_0';
          this.sites[id]['icon_mode_sf'] = 'mode_sf_0';
          this.sites[id]['icon_mode_cs'] = 'mode_cs_1';
          break;
        default:
          break;
      }
      const fanValue = this.getFanSetByLabel(this.sites[id]['pid'],this.xz_fan);
      setdetail['fan'] = fanValue;
      switch (this.xz_fan) {
        case "低风":
          this.sites[id]['icon_fs1'] = 'fs_1_1';
          this.sites[id]['icon_fs2'] = 'fs_2_0';
          this.sites[id]['icon_fs3'] = 'fs_3_0';
          this.sites[id]['icon_fszd'] = 'fs_zd_0';
          break;
        case "中风":
          this.sites[id]['icon_fs1'] = 'fs_1_0';
          this.sites[id]['icon_fs2'] = 'fs_2_1';
          this.sites[id]['icon_fs3'] = 'fs_3_0';
          this.sites[id]['icon_fszd'] = 'fs_zd_0';
          break;
        case "高风":
          this.sites[id]['icon_fs1'] = 'fs_1_0';
          this.sites[id]['icon_fs2'] = 'fs_2_0';
          this.sites[id]['icon_fs3'] = 'fs_3_1';
          this.sites[id]['icon_fszd'] = 'fs_zd_0';
          break;
        case "自动":
          this.sites[id]['icon_fs1'] = 'fs_1_0';
          this.sites[id]['icon_fs2'] = 'fs_2_0';
          this.sites[id]['icon_fs3'] = 'fs_3_0';
          this.sites[id]['icon_fszd'] = 'fs_zd_1';
          break;
        default:
          break;
      }
      if (parseInt(this.xz_temp_min) > 15 && parseInt(this.xz_temp_max) > 15) {
        if (this.sites[id]['temp_set'] < this.xz_temp_min) {
          this.sites[id]['temp_set'] = this.xz_temp_min;
        }
        if (this.sites[id]['temp_set'] > this.xz_temp_max) {
          this.sites[id]['temp_set'] = this.xz_temp_max;
        }
        setdetail['min_temp'] = this.xz_temp_min * 10;
        setdetail['max_temp'] = this.xz_temp_max * 10;
      }
      return setdetail;
    },
    show_ls_dialog(id) {
      this.roomid = id;
      this.roomid = id;
      this.xz_date = this.getYesterday();
      this.getLs_Data();
      this.dailogShow_ls = true;
    },
    Onclick(id,name) {
      console.log(id,name);
      this.isUpdate = false; /*控制后停止更新数据*/
      id = this.sites.findIndex((index) => { /*js快速查找数组索引*/
        if (index['id'] === id) {
          return true;
        }
      });
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'wg_mac':this.sites[id]['mac'],
        'wg_qid':this.sites[id]['qid'],
        'pid':this.sites[id]['pid']
      };
      switch (name) {
        case 'pwr': /*开关*/
          params['set_type'] = 'pwr';
          const currentPwr = this.pendingVal(this.sites[id],'pwr') !== undefined ? this.pendingVal(this.sites[id],'pwr'):this.sites[id]['pwr'];
          const targetPwr = currentPwr === 0 ? 1:0;
          this.setPending(this.sites[id]['id'],'pwr',targetPwr);
          params['set_val'] = targetPwr;
          if (this.sites[id]['online'] === 88) {
            if (this.timer_pwr) {
              clearTimeout(this.timer_pwr);
            }
            this.timer_pwr = setTimeout(() => {
              console.log("执行开关",params['set_val']);
              this.setData(params);
            },300);
          } else {
            this.isUpdate = true;
            this.$message.error(this.$t("您的设备离线了,请检查对应设备网络"));
          }
          return true; /*pwr分支处理完直接返回*/
        case 'sd': /*锁定*/
          if (!this.isLockEnabled(this.sites[id]['pid'])) {
            this.$message.warning(this.$t("该设备类型不支持锁定功能"));
            this.isUpdate = true;
            return true;
          }
          if (this.sites[id]['online'] === 88) {
            params['set_type'] = 'lock_many';
            if (this.sites[id]['kt_lock'] === 0) {
              this.dailog_xzVlue = id;
              this.sd_type = this.sites[id]["type"];
              this.isUpdate = false; /*停止更新数据*/
              this.dailogShow = true; /*显示锁定对话框*/
              return true; /*打开dailog后直接返回*/
            } else {
              this.sites[id]['bg_sd'] = this.bj_but_1;
              this.sites[id]['kt_lock'] = 0;
              params['set_val'] = {"lock_pwr":0};
            }
          } else {
            this.isUpdate = true;
            this.$message.error(this.$t("您的设备离线了,请检查对应设备网络"));
            return true;
          }
          break;
        case 'sf': /*水阀*/
          params['set_type'] = 6;
          if (this.sites[id]['kt_sfzt'] === 0) {
            this.sites[id]['bg_sf'] = this.bj_but;
            this.sites[id]['kt_sfzt'] = 1;
            params['set_val'] = 1;
          } else {
            this.sites[id]['bg_sf'] = this.bj_but_1;
            this.sites[id]['kt_sfzt'] = 0;
            params['set_val'] = 0;
          }
          break;
      }
      if (this.sites[id]['online'] === 88) {
        this.setData(params);
      } else {
        this.isUpdate = true;
        this.$message.error(this.$t("您的设备离线了,请检查对应设备网络"));
      }
    },
    OnTemp(id,name) { /*温度*/
      console.log(id,name);
      this.isUpdate = false; /*控制后停止更新数据*/
      id = this.sites.findIndex((index) => { /*js快速查找数组索引*/
        if (parseInt(index['id']) === parseInt(id)) {
          return true;
        }
      });
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'wg_mac':this.sites[id]['mac'],
        'wg_qid':this.sites[id]['qid'],
        'pid':this.sites[id]['pid']
      };
      params['set_type'] = 'temp';
      const tempLimit = this.getPidTempLimit(this.sites[id]['pid']);
      const step = tempLimit.step || 0.5;
      const currentTemp = this.pendingVal(this.sites[id],'temp_set') !== undefined ? this.pendingVal(this.sites[id],'temp_set'):parseFloat(this.sites[id]['temp_set']);
      switch (name) {
        case 'tempAdd':
          if (currentTemp + step <= tempLimit.maxTemp) {
            this.sites[id]['tempA'] = this.bj_but;
            const newTemp = Math.round((currentTemp + step) * 10) / 10;
            this.setPending(this.sites[id]['id'],'temp_set',newTemp);
            clearTimeout(this.timer_wd);  //清除温度延迟执行
            this.timer_wd = setTimeout(() => {   //设置延迟执行
              this.sites[id]['tempA'] = this.bj_but_color;
            },360);
            params['set_val'] = newTemp * 10;
            if (this.sites[id]['online'] === 88) {
              if (this.timer_temp) { //清除温度延迟执行
                clearTimeout(this.timer_temp);
              }
              this.timer_temp = setTimeout(() => {
                console.log("执行温度",params['set_val']);
                this.setData(params);
              },360);
            } else {
              this.isUpdate = true;
              this.$message.error(this.$t("您的设备离线了,请检查对应设备网络"));
            }
          }
          break;
        case 'tempDel':
          if (currentTemp - step >= tempLimit.minTemp) {
            this.sites[id]['tempD'] = this.bj_but;
            const newTemp = Math.round((currentTemp - step) * 10) / 10;
            this.setPending(this.sites[id]['id'],'temp_set',newTemp);
            clearTimeout(this.timer_wd);  //清除温度延迟执行
            this.timer_wd = setTimeout(() => {   //设置延迟执行
              this.sites[id]['tempD'] = this.bj_but_color;
            },300);
            params['set_val'] = newTemp * 10;
            if (this.sites[id]['online'] === 88) {
              if (this.timer_temp) {
                clearTimeout(this.timer_temp);  //清除温度延迟执行
              }
              this.timer_temp = setTimeout(() => {
                console.log("执行温度",params['set_val']);
                this.setData(params);
              },300);
            } else {
              this.isUpdate = true;
              this.$message.error(this.$t("您的设备离线了,请检查对应设备网络"));
            }
          }
          break;
      }
    },
    OnMode(id,name) { /*模式*/
      console.log(id,name);
      this.isUpdate = false; /*控制后停止更新数据*/
      id = this.sites.findIndex((index) => { /*js快速查找数组索引*/
        if (index['id'] === id) {
          return true;
        }
      });
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'wg_mac':this.sites[id]['mac'],
        'wg_qid':this.sites[id]['qid'],
        'pid':this.sites[id]['pid']
      };
      params['set_type'] = 'mode';
      const currentMode = this.pendingVal(this.sites[id],'mode') !== undefined ? this.pendingVal(this.sites[id],'mode'):this.sites[id]['mode'];
      const nextMode = this.getNextMode(this.sites[id]['pid'],currentMode);
      this.setPending(this.sites[id]['id'],'mode',nextMode);
      params['set_val'] = nextMode;
      if (this.sites[id]['online'] === 88) {
        if (this.timer_mode) {
          clearTimeout(this.timer_mode);
        }
        this.timer_mode = setTimeout(() => {
          console.log("执行模式",params['set_val']);
          this.setData(params);
        },300);
      } else {
        this.isUpdate = true;
        this.$message.error(this.$t("您的设备离线了,请检查对应设备网络"));
      }
    },
    OnFan(id,name) { /*风速*/
      console.log(id,name);
      this.isUpdate = false; /*控制后停止更新数据*/
      id = this.sites.findIndex((index) => { /*js快速查找数组索引*/
        if (index['id'] === id) {
          return true;
        }
      });
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'wg_mac':this.sites[id]['mac'],
        'wg_qid':this.sites[id]['qid'],
        'pid':this.sites[id]['pid']
      };
      params['set_type'] = 'fan';
      const currentFan = this.pendingVal(this.sites[id],'fan_set') !== undefined ? this.pendingVal(this.sites[id],'fan_set'):this.sites[id]['fan_set'];
      const nextFan = this.getNextFanSet(this.sites[id]['pid'],currentFan);
      this.setPending(this.sites[id]['id'],'fan_set',nextFan);
      params['set_val'] = nextFan;
      if (this.sites[id]['online'] === 88) {
        if (this.timer_fan) {
          clearTimeout(this.timer_fan);
        }
        this.timer_fan = setTimeout(() => {
          console.log("执行风速",params['set_val']);
          this.setData(params);
        },300);
      } else {
        this.isUpdate = true;
        this.$message.error(this.$t("您的设备离线了,请检查对应设备网络"));
      }
    },
    /* 根据pidLockMap判断指定PID是否支持锁定功能 */
    isLockEnabled(pid) {
      const cfg = this.pidLockMap[pid] || this.pidLockMap['default'];
      return cfg ? cfg.show !== false:true;
    },
    /* 根据pidDljMap判断指定PID是否支持多联机锁定功能 */
    isDljLockEnabled(pid) {
      const cfg = this.pidDljLock[pid] || this.pidDljLock['default'];
      return cfg ? cfg.show !== false:false;
    },
    /* 根据pidLockMap获取锁定状态显示文字 */
    getLockLabel(site) {
      if (!site.kt_lock) return '';
      const cfg = this.pidLockMap[site.pid] || this.pidLockMap['default'];
      if (!cfg || !cfg.lockList || cfg.lockList.length === 0) return this.$t('锁定');
      const matched = cfg.lockList.find(l => l.value === site.kt_lock);
      if (matched) return this.$t(matched.label);
      const firstLock = cfg.lockList.find(l => l.value !== 0);
      return firstLock ? this.$t(firstLock.label):this.$t('锁定');
    },
    /* 从pidTempLimitMap获取指定PID的温度限制配置 */
    getPidTempLimit(pid) {
      const cfg = this.pidTempLimitMap[pid] || this.pidTempLimitMap['default'] || {minTemp:10,maxTemp:50,step:0.5};
      return {
        minTemp:cfg.minTemp !== undefined ? cfg.minTemp:10,
        maxTemp:cfg.maxTemp !== undefined ? cfg.maxTemp:50,
        step:cfg.step !== undefined ? cfg.step:0.5,
        show:cfg.show !== undefined ? cfg.show:true
      };
    },
    /* 根据pidModeMap获取下一个可用模式值（循环） */
    getNextMode(pid,currentMode) {
      const list = this.pidModeMap[pid] || this.pidModeMap['default'];
      if (!list || list.length === 0) return currentMode;
      const idx = list.findIndex(m => m.value === currentMode);
      return list[(idx + 1) % list.length].value;
    },
    /* 根据pidFanMap获取下一个可用fan_set原始值（循环） */
    getNextFanSet(pid,currentFanSet) {
      const cfg = this.pidFanMap[pid] || this.pidFanMap['default'];
      const entries = Object.entries(cfg.displayToFanSet).sort((a,b) => parseInt(a[0]) - parseInt(b[0]));
      if (entries.length === 0) return currentFanSet;
      const idx = entries.findIndex(([display,raw]) => raw === currentFanSet);
      const nextIdx = (idx + 1) % entries.length;
      return entries[nextIdx][1];
    },
    /* 根据pidModeMap通过label查找模式value */
    getModeValueByLabel(pid,label) {
      const list = this.pidModeMap[pid] || this.pidModeMap['default'];
      const found = list.find(m => m.label === label);
      return found ? found.value:-1;
    },
    /* 根据pidFanMap通过label查找fan_set原始值 */
    getFanSetByLabel(pid,label) {
      const cfg = this.pidFanMap[pid] || this.pidFanMap['default'];
      const display = Object.keys(cfg.labels).find(k => cfg.labels[k] === label);
      if (display === undefined) return -1;
      return cfg.displayToFanSet[display] !== undefined ? cfg.displayToFanSet[display]:-1;
    },
    getModeText(site) {  /*根据设备模式返回文字描述，从pidModeMap字典查找*/
      const modeVal = this.pendingVal(site,'mode') !== undefined ? this.pendingVal(site,'mode'):site.mode;
      const list = this.pidModeMap[site.pid] || this.pidModeMap['default'];
      const found = list.find(m => m.value === modeVal);
      return found ? this.$t(found.label):this.$t('送风');
    },
    getSfText(site) { /*水阀显示：按pidSfMap，默认无水阀*/
      const cfg = this.pidSfMap[site.pid];
      if (!cfg) return ' ';
      if (cfg.type === 'num') { /*直接显示数值*/
        return site.sf_pwr !== undefined && site.sf_pwr !== null ? String(site.sf_pwr):' ';
      }
      /* kf 开关文字：0阀关 1阀开 */
      return site.sf_pwr === 1 ? this.$t('阀开'):this.$t('阀关');
    },
    getFanText(site) {
      /*根据pidFanMap字典查找风速文字*/
      const fanSetVal = this.pendingVal(site,'fan_set') !== undefined ? this.pendingVal(site,'fan_set'):site.fan_set;
      const cfg = this.pidFanMap[site.pid] || this.pidFanMap['default'];
      const display = this.fanSetToDisplay(fanSetVal,site.pid);
      return cfg.labels[display] ? this.$t(cfg.labels[display]):`${display}${this.$t('档')}`;
    },
    fanSetToDisplay(fanSet,pid) {
      const cfg = this.pidFanMap[pid] || this.pidFanMap['default'];
      for (const [display,raw] of Object.entries(cfg.displayToFanSet)) {
        if (raw === fanSet) return parseInt(display);
      }
      // 未找到匹配，返回最接近的档位
      return Math.max(1,Math.min(cfg.max,fanSet));
    },
    openKtDialog(site) { /*打开空调控制弹窗*/
      this.diaKtSite = {
        ...site,
        pwr:this.pendingVal(site,'pwr') !== undefined ? this.pendingVal(site,'pwr'):site.pwr,
        mode:this.pendingVal(site,'mode') !== undefined ? this.pendingVal(site,'mode'):site.mode,
        fan_set:this.pendingVal(site,'fan_set') !== undefined ? this.pendingVal(site,'fan_set'):site.fan_set,
        temp_set:this.pendingVal(site,'temp_set') !== undefined ? this.pendingVal(site,'temp_set'):site.temp_set,
        _pending:this.pendingMap[site.id] || {}
      };
      this.diaKtVisible = true;
    },
    openLogDevDialog(site) { /*打开控制日志弹窗*/
      this.diaLogDevSite = {...site};
      this.diaLogDevVisible = true;
    },
    /* ========== pending 状态管理方法 ========== */
    setPending(siteId,field,value) {
      /*设置待确认状态，36秒超时自动清除*/
      if (!this.pendingMap[siteId]) {
        this.$set(this.pendingMap,siteId,{});
      }
      this.$set(this.pendingMap[siteId],field,value);
      const timerKey = `pending_${siteId}_${field}`;
      if (this[timerKey]) {
        clearTimeout(this[timerKey]);
      }
      this[timerKey] = setTimeout(() => {
        this.clearPending(siteId,field);
      },36000);
    },
    clearPending(siteId,field) {
      /*清除指定字段的待确认状态*/
      if (this.pendingMap[siteId]) {
        this.$delete(this.pendingMap[siteId],field);
        if (Object.keys(this.pendingMap[siteId]).length === 0) {
          this.$delete(this.pendingMap,siteId);
        }
      }
      const timerKey = `pending_${siteId}_${field}`;
      if (this[timerKey]) {
        clearTimeout(this[timerKey]);
        this[timerKey] = null;
      }
    },
    clearAllPending(siteId) {
      /*清除设备全部待确认状态*/
      if (this.pendingMap[siteId]) {
        Object.keys(this.pendingMap[siteId]).forEach(field => {
          const timerKey = `pending_${siteId}_${field}`;
          if (this[timerKey]) {
            clearTimeout(this[timerKey]);
            this[timerKey] = null;
          }
        });
        this.$delete(this.pendingMap,siteId);
      }
    },
    clearPendingByParams(params) {
      /*根据控制参数清除对应pending，控制失败时让界面回跳到服务器实际值*/
      const setType = params['set_type'];
      const siteId = this.sites.findIndex(s => s.mac === params['wg_mac'] && String(s.qid) === String(params['wg_qid']));
      if (siteId === -1) return;
      const id = this.sites[siteId].id;
      const fieldMap = {
        'pwr':'pwr',
        'mode':'mode',
        'fan':'fan_set',
        'temp':'temp_set',
        'lock':'kt_lock',
        'lock_many':'kt_lock',
        'lock_temp':'kt_lock'
      };
      const field = fieldMap[setType];
      if (field) {
        this.clearPending(id,field);
      }
      /* pending 清除后，同步刷新弹窗数据 */
      this.updateDialogSiteData();
    },
    isPending(site,field) {
      /*判断指定字段是否处于待确认状态*/
      return !!(this.pendingMap[site.id] && this.pendingMap[site.id][field] !== undefined);
    },
    pendingVal(site,field) {
      /*获取待确认状态的值，如无则返回undefined*/
      if (this.pendingMap[site.id] && this.pendingMap[site.id][field] !== undefined) {
        return this.pendingMap[site.id][field];
      }
      return undefined;
    },
    onDialogControl({type,siteId,value}) { /*处理弹窗内的控制命令*/
      if (value !== undefined) { /*弹窗指定了模式值，直接设置，不走循环切换*/
        if (type === 'mode') {
          this.setDialogMode(siteId,value);
        } else if (type === 'fan') {
          this.setDialogFan(siteId,value);
        }
      } else {
        switch (type) {
          case 'pwr':
            this.Onclick(siteId,'pwr');
            break;
          case 'mode':
            this.OnMode(siteId,'mode');
            break;
          case 'fan':
            this.OnFan(siteId,'fan');
            break;
          case 'tempAdd':
            this.OnTemp(siteId,'tempAdd');
            break;
          case 'tempDel':
            this.OnTemp(siteId,'tempDel');
            break;
        }
      }
      /* 弹窗数据更新：用 nextTick 确保父组件 sites/pending 已更新后再同步 */
      this.$nextTick(() => {
        const idx = this.sites.findIndex(s => s.id === siteId);
        if (idx !== -1) {
          this.diaKtSite = {
            ...this.sites[idx],
            pwr:this.pendingVal(this.sites[idx],'pwr') !== undefined ? this.pendingVal(this.sites[idx],'pwr'):this.sites[idx].pwr,
            mode:this.pendingVal(this.sites[idx],'mode') !== undefined ? this.pendingVal(this.sites[idx],'mode'):this.sites[idx].mode,
            fan_set:this.pendingVal(this.sites[idx],'fan_set') !== undefined ? this.pendingVal(this.sites[idx],'fan_set'):this.sites[idx].fan_set,
            temp_set:this.pendingVal(this.sites[idx],'temp_set') !== undefined ? this.pendingVal(this.sites[idx],'temp_set'):this.sites[idx].temp_set,
            _pending:this.pendingMap[this.sites[idx].id] || {}
          };
        }
      });
    },
    setDialogMode(siteId,value) { /*弹窗直接设置指定模式值*/
      const idx = this.sites.findIndex(s => s.id === siteId);
      if (idx === -1) return;
      this.isUpdate = false;
      this.setPending(siteId,'mode',value);
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'wg_mac':this.sites[idx]['mac'],
        'wg_qid':this.sites[idx]['qid'],
        'pid':this.sites[idx]['pid'],
        'set_type':'mode',
        'set_val':value
      };
      if (this.sites[idx]['online'] === 88) {
        if (this.timer_mode) {
          clearTimeout(this.timer_mode);
        }
        this.timer_mode = setTimeout(() => {
          console.log("执行模式",value);
          this.setData(params);
        },300);
      } else {
        this.isUpdate = true;
        this.$message.error(this.$t("您的设备离线了,请检查对应设备网络"));
      }
    },
    setDialogFan(siteId,fanSetValue) { /*弹窗直接设置指定风速值*/
      const idx = this.sites.findIndex(s => s.id === siteId);
      if (idx === -1) return;
      this.isUpdate = false;
      this.setPending(siteId,'fan_set',fanSetValue);
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'wg_mac':this.sites[idx]['mac'],
        'wg_qid':this.sites[idx]['wg_qid'],
        'pid':this.sites[idx]['pid'],
        'set_type':'fan',
        'set_val':fanSetValue
      };
      if (this.sites[idx]['online'] === 88) {
        if (this.timer_fan) {
          clearTimeout(this.timer_fan);
        }
        this.timer_fan = setTimeout(() => {
          console.log("执行风速",fanSetValue);
          this.setData(params);
        },300);
      } else {
        this.isUpdate = true;
        this.$message.error(this.$t("您的设备离线了,请检查对应设备网络"));
      }
    },
    onDialogLock({siteId,lockValue}) { /*处理弹窗内的锁定设置*/
      const idx = this.sites.findIndex(s => s.id === siteId);
      if (idx === -1) return;
      if (!this.isLockEnabled(this.sites[idx]['pid'])) {
        this.$message.warning(this.$t("该设备类型不支持锁定功能"));
        return;
      }
      if (this.sites[idx]['online'] !== 88) {
        this.$message.error(this.$t("设备离线，无法设置锁定"));
        return;
      }
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'wg_mac':this.sites[idx]['mac'],
        'wg_qid':this.sites[idx]['qid'],
        'pid':this.sites[idx]['pid'],
        'set_type':'lock',
        'set_val':lockValue
      };
      this.sites[idx]['kt_lock'] = lockValue;
      this.sites[idx]['bg_sd'] = lockValue === 0 ? this.bj_but_1:this.bj_but;
      this.setData(params,true);
      this.diaKtSite = {...this.sites[idx]};
    },
    onDialogTempLimit({siteId,tempMin,tempMax}) { /*处理弹窗内的温度限制*/
      const idx = this.sites.findIndex(s => s.id === siteId);
      if (idx === -1) return;
      if (this.sites[idx]['online'] !== 88) {
        this.$message.error(this.$t("设备离线，无法设置温度限制"));
        return;
      }
      /* 温度限制与锁定状态无关，记录当前锁定状态用于后续忽略自动变半锁 */
      this.$set(this.tempLimitLockPreserve,siteId,this.sites[idx]['kt_lock']);
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'wg_mac':this.sites[idx]['mac'],
        'wg_qid':this.sites[idx]['qid'],
        'pid':this.sites[idx]['pid'],
        'set_type':'lock_temp',
        'set_val':{
          "cold_min":parseInt(tempMin) * 10,
          "cold_max":parseInt(tempMax) * 10,
          "heat_min":parseInt(tempMin) * 10,
          "heat_max":parseInt(tempMax) * 10
        }
      };
      this.setData(params,true);
    },
    /* ========== 多联机锁定事件处理 ========== */
    onDialogDljBatchLock({siteId,wg_mac,wg_qid,pid,pwr,mode,fan,tempMin,tempMax,lockTemp}) { /*多联机批量锁定*/
      const idx = this.sites.findIndex(s => s.id === siteId);
      if (idx === -1) return;
      if (this.sites[idx]['online'] !== 88) {
        this.$message.error(this.$t("设备离线，无法设置锁定"));
        return;
      }
      const cfg = this.pidDljLock[this.sites[idx]['pid']] || this.pidDljLock['default'];
      if (!cfg || cfg.show === false) {
        this.$message.warning(this.$t("该设备类型不支持多联机锁定功能"));
        return;
      }
      /* 构建锁定参数：未选中的字段用 -1 占位，有任一选中项时 lock_pwr=1 */
      const hasLockItem = (pwr !== null && pwr !== undefined) ||
        (mode !== null && mode !== undefined) ||
        (fan !== null && fan !== undefined) ||
        lockTemp;
      let setVal = {
        lock_pwr:hasLockItem ? 1:0,
        pwr:(pwr !== null && pwr !== undefined) ? pwr:-1,
        mode:(mode !== null && mode !== undefined) ? mode:-1,
        fan:(fan !== null && fan !== undefined) ? fan:-1
      };
      if (lockTemp) {
        setVal.min_temp = parseInt(tempMin) * 10;
        setVal.max_temp = parseInt(tempMax) * 10;
      }
      let params = {
        'li_data':[
          {
            'wg_mac':wg_mac || this.sites[idx]['mac'],
            'wg_qid':wg_qid || this.sites[idx]['wg_qid'] || this.sites[idx]['qid'],
            'pid':pid || this.sites[idx]['pid'],
            'set_type':'lock_many',
            'set_val':setVal
          }
        ]
      };
      this.setManyData(params,true);
      this.$message.success(this.$t("批量锁定已发送"));
    },
    onDialogDljBatchUnlock({siteId,wg_mac,wg_qid,pid}) { /*多联机批量解锁*/
      const idx = this.sites.findIndex(s => s.id === siteId);
      if (idx === -1) return;
      if (this.sites[idx]['online'] !== 88) {
        this.$message.error(this.$t("设备离线，无法设置解锁"));
        return;
      }
      const cfg = this.pidDljLock[this.sites[idx]['pid']] || this.pidDljLock['default'];
      if (!cfg || cfg.show === false) {
        this.$message.warning(this.$t("该设备类型不支持多联机锁定功能"));
        return;
      }
      let params = {
        'li_data':[
          {
            'wg_mac':wg_mac || this.sites[idx]['mac'],
            'wg_qid':wg_qid || this.sites[idx]['wg_qid'] || this.sites[idx]['qid'],
            'pid':pid || this.sites[idx]['pid'],
            'set_type':'lock_many',
            'set_val':{"lock_pwr":0}
          }
        ]
      };
      this.setManyData(params,true);
      this.$message.success(this.$t("批量解锁已发送"));
    },
    updateDialogSiteData() { /*数据刷新时同步更新弹窗中的设备数据*/
      if (!this.diaKtVisible || !this.diaKtSite || !this.diaKtSite.id) return;
      const idx = this.sites.findIndex(s => s.id === this.diaKtSite.id);
      if (idx !== -1) {
        const site = this.sites[idx];
        /*弹窗数据也应用pending覆盖，保持与列表一致*/
        this.diaKtSite = {
          ...site,
          pwr:this.pendingVal(site,'pwr') !== undefined ? this.pendingVal(site,'pwr'):site.pwr,
          mode:this.pendingVal(site,'mode') !== undefined ? this.pendingVal(site,'mode'):site.mode,
          fan_set:this.pendingVal(site,'fan_set') !== undefined ? this.pendingVal(site,'fan_set'):site.fan_set,
          temp_set:this.pendingVal(site,'temp_set') !== undefined ? this.pendingVal(site,'temp_set'):site.temp_set,
          _pending:this.pendingMap[site.id] || {}
        };
      }
    },

    handleCheckAllChange(val) { /*全选，勾选框*/
      this.checkAll = val;
      for (var i = 0; i < this.sites.length; i++) {
        this.sites[i].check = val;
      }
    },
    checkChange(id) { /*单个勾选*/
      this.checkAll = false;
      // id = this.sites.findIndex((index) => { /*js快速查找数组索引*/
      //   if (index['id'] === id) {
      //     return true
      //   }
      // })
      // this.checkAll[id] = 1
      // if (this.sites[id]['check']){}
      // console.log(id, site.check)
      // this.checkList[id] = val
    },
    setData(params,isToast = true) {  /*发送控制数据*/
      // const params = {'username': this.loginForm.username, 'userpwd': this.loginForm.password}
      // let loading = this.$loading({spinner: "", text: "发送数据中...", background: "rgba(0, 0, 0, 0.3)"});
      params["ctr_type"] = "set_one";
      params["kt_sonid"] = localStorage.getItem('kt_sonid');
      console.log(params);
      // let a = {"mac": params.wg_mac, "wg_qid": params.wg_qid, "set_type": params.set_type, "set_val": params.set_val}
      this.$api.post(this.$urls.ip + this.$urls.devCtr,params).then(res => {
        // loading.close()
        if (isToast) {
          if (res.data['code'] === 200) {
            this.$message.success(this.$t("控制成功"));
            clearTimeout(this.timer_kz);  //清除延迟更新状态
            this.timer_kz = setTimeout(() => {   //设置延迟执行
              this.isUpdate = true; /*继续更新数据*/
            },36000);
          } else {
            /* 控制失败：清除对应 pending，让界面回跳到服务器实际值 */
            this.clearPendingByParams(params);
          }
        }
      }).catch(error => {
        console.log("控制设备报错：" + error);
        this.$message.error(this.$t("控制失败"));
        /* 请求异常：清除对应 pending，让界面回跳 */
        this.clearPendingByParams(params);
        this.sendMsg([{"wg_mac":params['wg_mac'],"wg_qid":params['wg_qid']}]);
        if (isToast) {
          this.isUpdate = true; /*继续更新数据*/
        }
      });
    },
    setManyData(params,isToast = true) {  /*发送群控数据（多联机批量锁定/解锁）*/
      params["ctr_type"] = "set_many";
      params["kt_token"] = localStorage.getItem('token');
      params["kt_dwid"] = localStorage.getItem('did');
      params["kt_sonid"] = localStorage.getItem('kt_sonid');
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.devManyCtr,params).then(res => {
        if (isToast) {
          if (res.data['code'] === 200) {
            this.$message.success(this.$t("控制成功"));
            clearTimeout(this.timer_kz);  //清除延迟更新状态
            this.timer_kz = setTimeout(() => {   //设置延迟执行
              this.isUpdate = true; /*继续更新数据*/
            },36000);
          } else {
            /* 控制失败：清除对应 pending */
            if (params.li_data) {
              params.li_data.forEach(item => {
                this.clearPendingByParams(item);
              });
            }
          }
        }
      }).catch(error => {
        console.log("控制设备报错：" + error);
        this.$message.error(this.$t("控制失败"));
        /* 请求异常：清除对应 pending */
        if (params.li_data) {
          params.li_data.forEach(item => {
            this.clearPendingByParams(item);
          });
        }
        if (isToast) {
          this.isUpdate = true; /*继续更新数据*/
        }
      });
    },
    sendMsg(li_msg) {
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        "kt_sonid":localStorage.getItem('kt_sonid'),
        "ctr_type":"get_webMsg",
        "li_data":li_msg
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getWebMsg,params).then(res => {
        console.log("获取消息成功");
      }).catch(error => {
        console.log("获取消息失败：" + error);
        // this.$message.error("获取消息失败");
      });
    },
    allDvsCtrol(val) { /*全选设备控制*/
      console.log(val,this.edi_kg);
      /*this.isUpdate = false*/ /*控制后停止更新数据*/
      let loading = this.$loading({spinner:"",text:this.$t("发送数据中..."),background:"rgba(0, 0, 0, 0.3)"});
      let isKz = 0;
      for (var i = 0; i < this.sites.length; i++) {
        let id = i;
        if (this.sites[id]['check']) {
          if (val === '锁定' && !this.isLockEnabled(this.sites[id]['pid'])) {
            this.sites[id]['check'] = false;
            continue;
          }
          isKz = 1;
          this.isUpdate = false; /*控制后停止更新数据*/
          // this.timer_yskz = setTimeout(() => {
          let params = {
            'kt_token':localStorage.getItem('token'),
            'kt_dwid':localStorage.getItem('did'),
            'wg_mac':this.sites[id]['mac'],
            'wg_qid':this.sites[id]['qid'],
            'pid':this.sites[id]['pid']
          };
          /*params['set_type'] = 1
           params['set_val'] = 0*/
          switch (val) {
            case '开关':
              params['set_type'] = 2;
              if (this.edi_kg === "开机") {
                params['set_val'] = 1;
                this.sites[id]['icon_pow'] = "pow_1";
                this.sites[id]['pwr'] = 1;
                this.sites[id]['bg_dy'] = this.bj_but;
              } else {
                params['set_val'] = 0;
                this.sites[id]['icon_pow'] = "pow_0";
                this.sites[id]['pwr'] = 0;
                this.sites[id]['bg_dy'] = this.bj_but_1;
              }
              break;
            case '模式':
              params['set_type'] = 3;
              params['set_val'] = this.getModeValueByLabel(this.sites[id]['pid'],this.edi_mode);
              if (this.edi_mode === "制热") {
                this.sites[id]['icon_mode_re'] = 'mode_re_1';
                this.sites[id]['icon_mode_len'] = 'mode_len_0';
                this.sites[id]['icon_mode_sf'] = 'mode_sf_0';
                this.sites[id]['icon_mode_cs'] = 'mode_cs_0';
              } else if (this.edi_mode === "制冷") {
                this.sites[id]['icon_mode_re'] = 'mode_re_0';
                this.sites[id]['icon_mode_len'] = 'mode_len_1';
                this.sites[id]['icon_mode_sf'] = 'mode_sf_0';
                this.sites[id]['icon_mode_cs'] = 'mode_cs_0';
              } else if (this.edi_mode === "送风") {
                this.sites[id]['icon_mode_re'] = 'mode_re_0';
                this.sites[id]['icon_mode_len'] = 'mode_len_0';
                this.sites[id]['icon_mode_sf'] = 'mode_sf_1';
                this.sites[id]['icon_mode_cs'] = 'mode_cs_0';
              } else if (this.edi_mode === "除湿") {
                this.sites[id]['icon_mode_re'] = 'mode_re_0';
                this.sites[id]['icon_mode_len'] = 'mode_len_0';
                this.sites[id]['icon_mode_sf'] = 'mode_sf_0';
                this.sites[id]['icon_mode_cs'] = 'mode_cs_1';
              }
              break;
            case '风速':
              params['set_type'] = 5;
              const fanLabelMap = {'低速':'低风','中速':'中风','高速':'高风','自动':'自动'};
              const fanLabel = fanLabelMap[this.edi_fan] || this.edi_fan;
              params['set_val'] = this.getFanSetByLabel(this.sites[id]['pid'],fanLabel);
              if (this.edi_fan === "低速") {
                this.sites[id]['icon_fs1'] = 'fs_1_1';
                this.sites[id]['icon_fs2'] = 'fs_2_0';
                this.sites[id]['icon_fs3'] = 'fs_3_0';
                this.sites[id]['icon_fszd'] = 'fs_zd_0';
              } else if (this.edi_fan === "中速") {
                this.sites[id]['icon_fs1'] = 'fs_1_0';
                this.sites[id]['icon_fs2'] = 'fs_2_1';
                this.sites[id]['icon_fs3'] = 'fs_3_0';
                this.sites[id]['icon_fszd'] = 'fs_zd_0';
              } else if (this.edi_fan === "高速") {
                this.sites[id]['icon_fs1'] = 'fs_1_0';
                this.sites[id]['icon_fs2'] = 'fs_2_0';
                this.sites[id]['icon_fs3'] = 'fs_3_1';
                this.sites[id]['icon_fszd'] = 'fs_zd_0';
              } else if (this.edi_fan === "自动") {
                this.sites[id]['icon_fs1'] = 'fs_1_0';
                this.sites[id]['icon_fs2'] = 'fs_2_0';
                this.sites[id]['icon_fs3'] = 'fs_3_0';
                this.sites[id]['icon_fszd'] = 'fs_zd_1';
              }
              break;
            case '温度':
              params['set_type'] = 1;
              params['set_val'] = this.edi_temp * 10;
              this.sites[id]['temp_set'] = this.edi_temp;
              break;
            case '锁定':
              if (this.edi_sd === "解锁") {
                params['set_type'] = 34;
                params['set_val'] = 0;
                this.sites[id]['bg_sd'] = this.bj_but_1;
                this.sites[id]['kt_lock'] = 0;
              } else {
                loading.close(); /*取消加载框*/
                this.dailog_xzVlue = -1;  /*用于判断勾选框*/
                this.isUpdate = false; /*停止更新数据*/
                this.dailogShow = true;
                return true; /*弹出锁定dialog后直接返回*/
              }
              break;
          }
          if (this.sites[id]['online'] === 88) {
            this.setData(params,false);
          }
          this.sites[id]['check'] = false;
          // }, 600 * i);
        }
        clearTimeout(this.timer_kz);  //清除延迟更新状态
        this.timer_kz = setTimeout(() => {   //设置延迟执行
          this.isUpdate = true; /*继续更新数据*/
        },36000);
      }
      loading.close();
      this.checkAll = false; /*取消全选框*/
      if (isKz) {
        this.$message.success(this.$t("控制成功"));
      } else {
        this.$message.error(this.$t("请先勾选设备"));
      }
      // this.$refs.select.focus()
      this.$refs.select.blur();
      this.$refs.select1.blur();
      this.$refs.select2.blur();
      this.$refs.select3.blur();
      this.$refs.select4.blur(); /*屏蔽焦点，解决切换页面下拉问题*/
    },
    initHead() {
      this.area_max = localStorage.getItem('area_max');
      switch (this.area_max) {
        case "area":
          this.get_area(true);
          this.get_building();
          this.get_unit();
          break;
        case "building":
          this.get_area(true);
          this.get_building();
          this.get_unit();
          break;
        case "unit":
          this.get_building(true);
          this.get_unit();
          break;
        case "floor":
          this.get_unit(true);
          break;
      }
      this.get_floor();
      this.get_room();
    },
    init_View() { /*更新表格数据*/
      let isIncremental = this.li_id.length > 0; /*判断是增量更新还是全新加载*/
      let lSites = [];
      /*{
       id: 0, name: '网关112', check: true,
       uptime: '2023-08-22 18:59:32', sum_runtime: 1.5,
       temp_set: 16, temp: 20, tempA: '#000000', tempD: '#000000',
       icon_xh: 'xh_1', xh: 70, /!*信号 xh*!/
       icon_tx: 'tx', /!*网关通讯 online*!/
       icon_mode_len: 'mode_len_1', /!*模式 kt_mode*!/
       icon_mode_re: 'mode_re_0', icon_mode_sf: 'mode_sf_0',
       icon_fs1: 'fs_1_1', icon_fs2: 'fs_2_0', icon_fs3: 'fs_3_0', icon_fszd: 'fs_zd_0', /!*风速 kt_fengsuset*!/
       kt_sfzt: 0, kt_lock: 0, pwr: 0,
       bg_sf: '#ffffff', bg_sd: '#ffffff', bg_dy: '#ffffff'
       }*/
      let li_msg = [];
      let data = this.roomData;
      console.log(this.sx_familyId,this.sx_familyName); /*打印过滤条件*/
      let is_Zj = false;
      for (var i = 0; i < data.length; i++) {
        let d_data = {
          id:data[i]['dev_id'],
          mac:data[i]['wg_mac'],
          wg_mac:data[i]['wg_mac'],
          wg_qid:data[i]['wg_qid'],
          qid:data[i]['wg_qid'],
          pid:data[i]['pid'],
          check:false,
          uptime:data[i]['uptime'],
          sum_runtime:data[i]['sum_runtime'],
          unit_id:data[i]['unit_id'],
          temp_set:data[i]['temp_set'] / 10,
          temp:data[i]['temp'] / 10,
          tempA:this.bj_but_color,
          tempD:this.bj_but_color,
          xh:data[i]['xh'],
          sf_pwr:data[i]['sf_pwr'],
          kt_lock:data[i]['kt_lock'],
          pwr:data[i]['pwr'],
          kt_err:data[i]['err'],
          fan:data[i]['fan'],
          fan_set:data[i]['fan_set'],
          mode:data[i]['mode'],
          online:data[i]['online'],
          stop_logo:data[i]['stop_logo'],
          stop_czTime:data[i]['stop_czTime']
        };
        if (!d_data.mac) {
          continue;
        } else if (!this.fil_mac.includes(d_data.mac.slice(0,10).toLowerCase())) {  /*"0100000001"*/
          li_msg.push({"wg_mac":d_data['wg_mac'],"wg_qid":d_data['wg_qid']});
        } else if (!this.li_id.includes(d_data['id'])) {
          this.li_id.push(d_data['id']);
        }
        if (!this.li_mac.includes(d_data.mac)) {
          this.li_mac.push(d_data.mac.toLowerCase());
        }
        d_data['area_name'] = data[i]["area_name"];   /*小区*/
        d_data['area_id'] = data[i]["area_id"];   /*小区*/
        d_data['building_name'] = data[i]["building_name"];   /*楼栋*/
        d_data['building_id'] = data[i]["building_id"];   /*楼栋*/
        d_data['unit_id'] = data[i]["unit_id"];   /*单元*/
        d_data['unit_name'] = data[i]["unit_name"];   /*单元*/
        d_data['floor_name'] = data[i]["floor_name"];   /*楼层*/
        d_data['floor_id'] = data[i]["floor_id"];   /*楼层*/
        d_data['room_name'] = data[i]["room_name"]; /*房间*/
        d_data['room_id'] = data[i]["room_id"]; /*房间*/
        d_data['dev_name'] = data[i]["dev_name"]; /*房间*/
        d_data['dev_id'] = data[i]["dev_id"]; /*房间*/
        d_data['wg_id'] = data[i]["wg_id"]; /*房间*/
        d_data['wg_qid'] = data[i]["wg_qid"]; /*房间*/
        d_data['dev_bz'] = data[i]['dev_bz'];
        d_data['pid'] = data[i]['pid'];
        d_data['type'] = data[i]['pid'];
        d_data['dev_type_name'] = data[i]['dev_type_name'];
        if (this.sx_familyId === "lou") { /*按楼筛选出设备*/
          if (this.sx_familyName !== d_data['floor_name']) {
            continue;
          }
        } else if (this.sx_familyId === "ceng") { /*按层筛选出设备*/
          if (this.sx_familyName !== d_data['room_name'] || this.sx_flou !== d_data['floor_name']) {
            continue;
          }
        } else if (this.sx_familyId === "jian") { /*按房间筛选出设备*/
          if (this.sx_familyName !== d_data['dev_name'] || this.sx_flou !== d_data['floor_name']
            || this.sx_fceng !== d_data['room_name']) {
            continue;
          }
        }
        d_data['bg_sf'] = this.bj_but_1;
        d_data['kt_sfzt'] = 0;
        // }
        if (d_data['kt_lock']) {
          if (d_data['kt_lock'] === 0) { /*锁定*/
            d_data['bg_sd'] = this.bj_but_1;
            d_data['kt_lock'] = 0;
          } else {
            d_data['bg_sd'] = this.bj_but;
          }
        } else {
          d_data['bg_sd'] = this.bj_but_1;
          d_data['kt_lock'] = 0;
        }
        if (d_data['pwr'] === 1) { /*开关*/
          d_data['bg_dy'] = this.bj_but;
        } else {
          d_data['bg_dy'] = this.bj_but_1;
          d_data['pwr'] = 0;
        }
        if (d_data['xh'] > -85) { /*网关信号*/
          d_data['icon_xh'] = "xh_4";
        } else if (d_data['xh'] > -100) {
          d_data['icon_xh'] = "xh_3";
        } else if (d_data['xh'] > -110) {
          d_data['icon_xh'] = "xh_2";
        } else if (d_data['xh'] > -125) {
          d_data['icon_xh'] = "xh_1";
        } else {
          d_data['icon_xh'] = "xh";
        }
        d_data['icon_pow'] = "pow_0";
        if (d_data['stop_czTime'] === 1) { /*干接点*/
          d_data['icon_gjd'] = "gjd";
        }
        if (d_data['online'] === 88 || d_data['online'] === 66) { /*网关通讯状态*/
          d_data['online'] = 88;
          d_data['icon_tx'] = "tx";
          d_data['dev_status'] = this.$t('在线'); /*网关状态*/
          if (d_data['pwr'] === 1) { /*开关*/
            d_data['icon_pow'] = "pow_1";
          }
        } else if (d_data['online'] === 44) {
          d_data['icon_tx'] = "tx_-1";
          d_data['dev_status'] = this.$t('离线'); /*网关状态-内机离线*/
          d_data['icon_xh'] = "xh";
        } else {
          d_data['icon_tx'] = "tx_0";
          d_data['dev_status'] = this.$t('离线'); /*网关状态-网关离线*/
          d_data['icon_xh'] = "xh";
        }
        if (d_data['kt_err'] && d_data['kt_err'] !== "0") {
          if (!d_data['kt_err'].includes("00000000")) {
            d_data['icon_tx'] = "tx_-1";
            d_data['dev_status'] = this.$t('空调内机故障：') + d_data['kt_err'];/*网关状态-内机离线*/
          }
        }
        if (isIncremental) {
          /*增量更新：找到对应设备更新部分数据，保留check状态避免闪烁*/
          let siteIndex = this.sites.findIndex(s => s.id === d_data['id']);
          if (siteIndex !== -1) {
            let checkState = this.sites[siteIndex].check;
            /* 保留当前 pending 状态，避免轮询数据把用户操作覆盖 */
            const siteId = d_data['id'];
            const pendingFields = this.pendingMap[siteId] ? Object.keys(this.pendingMap[siteId]):[];
            pendingFields.forEach(field => {
              if (field !== 'timer') {
                d_data[field] = this.pendingMap[siteId][field];
              }
            });
            this.$set(this.sites,siteIndex,{...d_data,check:checkState});
          } else {
            this.sites.push(d_data);
          }
        } else {
          lSites.push(d_data);
        }
      }
      if (!isIncremental) {
        /*全新加载才排序和整体赋值*/
        if (this.changeName) {
          lSites = this.bubbleSort(lSites,'dev_id');
        } else {
          lSites = this.bubbleSort3(lSites,[
            "unit_name",
            "floor_name",
            "room_name",
            "dev_name"
          ]);
        }
        this.sites = lSites;
        /* 全新加载时清空全部 pending */
        Object.keys(this.pendingMap).forEach(siteId => {
          this.clearAllPending(parseInt(siteId));
        });
      }
      //this.sites = lSites.slice((this.page - 1) * this.pageSize,this.page * this.pageSize);
      if (is_Zj && this.isZJ_show) { /*增加水冷和风冷主机控制*/
        let l_d = {
          id:-1,name:'zj',v:0,flou:"",fceng:"",label:"主机控制",
          children:[],louid:-1
        };
        this.treeData[0].children.push(l_d);
        this.isZJ_show = false;
      }
      if (!isIncremental) {
        setTimeout(() => {
          for (let i = 0; i < this.li_mac.length; i++) {
            if (!this.fil_mac.includes(this.li_mac[i].slice(0,10).toLowerCase())) {
              this.addTopic(`devS/${this.li_mac[i].toLowerCase()}`);
            }
          }
          if (li_msg.length > 0) {
            this.sendMsg(li_msg);
          }
        },600);
      }
      /*弹窗打开时同步更新设备数据*/
      this.updateDialogSiteData();
    },
    timeBj(old_date) { /*对比时间差*/
      let date1 = new Date();
      let date2 = new Date(old_date);
      return date1.getTime() - date2.getTime() < 30 * 60 * 1000;
    },
    naturalCompare(a,b) {
      if (!a && !b) return 0;
      if (!a) return -1;
      if (!b) return 1;

      // 将字符串拆分为 [数字, 非数字, 数字, 非数字...] 的片段数组
      const tokenize = (str) => String(str).match(/\d+|\D+/g) || [];

      const tokensA = tokenize(a);
      const tokensB = tokenize(b);
      const len = Math.min(tokensA.length,tokensB.length);

      for (let i = 0; i < len; i++) {
        const tokenA = tokensA[i];
        const tokenB = tokensB[i];

        // 判断当前片段是否都是纯数字
        const numA = parseInt(tokenA,10);
        const numB = parseInt(tokenB,10);
        const isNumA = !isNaN(numA) && /^\d+$/.test(tokenA);
        const isNumB = !isNaN(numB) && /^\d+$/.test(tokenB);

        if (isNumA && isNumB) {
          // 数字片段按数值比较
          if (numA !== numB) return numA - numB;
        } else {
          // 非数字片段按字符串比较（如需忽略大小写，改为 tokenA.toLowerCase()）
          if (tokenA !== tokenB) return tokenA > tokenB ? 1:-1;
        }
      }

      // 如果前面都相等，短的排前面
      return tokensA.length - tokensB.length;
    },
    bubbleSort(arr,name) { /*数据排序,防止乱跳*/
      for (var i = 1; i <= arr.length - 1; i++) {
        var preIndex = i - 1;
        var current = arr[i];
        // 替换原有的字符串比较：arr[preIndex][name] > current[name]
        while (preIndex >= 0 && this.naturalCompare(arr[preIndex][name],current[name]) > 0) {
          arr[preIndex + 1] = arr[preIndex];
          preIndex--;
        }
        arr[preIndex + 1] = current;
      }
      return arr;
    },
    bubbleSort3(arrayOfObjects,keys) { /*4层数据排序,防止乱跳*/
      return arrayOfObjects.sort((objA,objB) => {
        for (let i = 0; i < keys.length; ++i) {
          let key = keys[i];
          if (objA[key] < objB[key]) return -1;
          if (objA[key] > objB[key]) return 1;
        }
        return 0;
      });
    },
    getDevData(li_id = []) { /*获取数据更新界面*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'kt_type':1, /*1空调内机、2空调主机、3传感器*/
        'page':this.page,
        'pageSize':this.pageSize
      };
      if (this.dev_name1) {
        params['dev_name'] = this.dev_name1;
      }
      if (this.edi_state) {
        params['dev_status'] = this.edi_state;
      }
      if (this.edi_pwr || this.edi_pwr === 0) {
        params['pwr'] = this.edi_pwr;
      }
      if (li_id && li_id.length > 0) {
        params['li_id'] = li_id.join(',');
      } else {
        this.li_id = [];
        this.li_mac = [];
        this.unsubscribeAll(); /*mqtt*/
      }
      switch (this.xz_area) {
        case "area":
          params["area_id"] = this.xz_id;
          break;
        case "building":
          params["building_id"] = this.xz_id;
          break;
        case "unit":
          params["unit_id"] = this.xz_id;
          break;
        case "floor":
          params["floor_id"] = this.xz_id;
          break;
        case "room":
          params["room_id"] = this.xz_id;
          break;
        case "dev":
          params["dev_id"] = this.xz_id;
          break;
      }
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.get_dev_list,params).then(res => {
        this.loading.close();
        if (li_id.length === 0) {
          this.total = res.data['total'];
        }
        this.roomData = res.data['data'];
        console.log("拿到设备最新状态",this.roomData);
        this.loading.close();
        this.init_View();
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取房间数据失败，请点击左上角刷新按钮"));
      });
    },
    get_devType() { /*获取设备类型*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100000
      };
      this.$api.get(this.$urls.ip + this.$urls.getTypeDev,params).then(res => {
        this.type_data = res.data['data'];
        console.log("拿到设备类型信息",this.type_data);
        let l = [];
        for (let i = 0; i < this.type_data.length; i++) {
          let d = {
            pid:this.type_data[i]['pid'],
            value:this.type_data[i]['pid'],
            label:this.type_data[i]['dev_type_name']
          };
          l.push(d);
        }
        console.log(l);
        this.dev_type_list = l;
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取设备类型数据失败"));
      });
    },
    get_area_list() { /*获取区域信息*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100000
      };
      this.$api.get(this.$urls.ip + this.$urls.get_area_list,params).then(res => {
        this.area_list1 = res.data['data'];
        this.threeHand3(); /*左侧导航栏处理*/
        console.log("拿到区域信息",this.area_list1);
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("拿到区域信息失败"));
      });
    },
    get_area(isMaxArea = false) {
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100
      };
      this.$api.get(this.$urls.ip + this.$urls.get_area,params).then(res => {
        this.area_data = res.data['data'];
        let l = [];
        for (let i = 0; i < this.area_data.length; i++) {
          let d = {
            value:this.area_data[i]['area_id'],
            label:this.area_data[i]['area_name']
          };
          l.push(d);
        }
        if (isMaxArea && l.length > 0) {
          this.maxArea_id = l[0]['value'];
        }
        this.area_list = l;
        this.ssarea_list = l;
        console.log("拿到区域信息",l);
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取区域数据失败，请点击左上角刷新按钮"));
      });
    },
    get_building(isMaxArea = false) {
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100
      };
      this.$api.get(this.$urls.ip + this.$urls.get_building,params).then(res => {
        console.log("拿到楼栋信息",res.data['data']);
        this.building_data = res.data['data'];
        let l = [];
        for (let i = 0; i < this.building_data.length; i++) {
          let d = {
            value:this.building_data[i]['building_id'],
            label:this.building_data[i]['building_name']
          };
          l.push(d);
        }
        if (isMaxArea && l.length > 0) {
          this.maxArea_id = l[0]['value'];
        }
        this.building_list = l;
        this.ssbuilding_list = l;
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取楼栋数据失败"));
      });
    },
    get_unit(isMaxArea = false) { /*获取楼栋*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100000
      };
      this.$api.get(this.$urls.ip + this.$urls.get_unit,params).then(res => {
        this.unit_data = res.data['data'];
        let l = [];
        for (let i = 0; i < this.unit_data.length; i++) {
          let d = {
            value:this.unit_data[i]['unit_id'],
            label:this.unit_data[i]['unit_name']
          };
          l.push(d);
        }
        if (isMaxArea && l.length > 0) {
          this.maxArea_id = l[0]['value'];
        }
        this.unit_list = l;
        this.ssunit_list = l;
        console.log("拿到单元信息",l);
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取单元数据失败"));
      });
    },
    get_floor(isMaxArea = false) { /*获取楼层信息*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100000
      };
      this.$api.get(this.$urls.ip + this.$urls.get_floor,params).then(res => {
        console.log("1111",res.data['data']);
        let l_d = res.data['data'];
        let l = [];
        for (let i = 0; i < l_d.length; i++) {
          let d = {
            value:l_d[i]['floor_id'],
            label:l_d[i]['floor_name'],
            unit_id:l_d[i]['unit_id']
          };
          l.push(d);
        }
        l = this.bubbleSort(l,"label");
        if (isMaxArea && l.length > 0) {
          this.maxArea_id = l[0]['value'];
        }
        console.log("最大区域",this.maxArea_id);
        this.li_floor = l;
        this.list_floor = l;
        console.log("拿到楼层信息",this.list_floor);
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取楼层数据失败"));
      });
    },
    get_room(isMaxArea = false) { /*获取房间*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100000
      };
      this.$api.get(this.$urls.ip + this.$urls.get_room,params).then(res => {
        console.log("拿到房间信息",res.data['data']);
        let l_d = res.data['data'];
        let l = [];
        for (let i = 0; i < l_d.length; i++) {
          let d = {
            value:l_d[i]['room_id'],
            label:l_d[i]['room_name'],
            floor_id:l_d[i]['floor_id']
          };
          l.push(d);
        }
        l = this.bubbleSort(l,"label");
        if (isMaxArea && l.length > 0) {
          this.maxArea_id = l[0]['value'];
        }
        this.li_room = l;
        this.list_room = l;
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取房间数据失败"));
      });
    },
    xhTime() { /*循环定时*/
      this.timer = setInterval(() => {   //设置延迟执行
        if (this.isUpdate) {
          if (this.li_id && this.li_id.length > 0) {
            console.log("11111");
            this.getDevData(this.li_id);
          }
        }
      },20000);
    },
    webConect() {
      this.client = mqtt.connect(`${this.$urls.webMsg}/mqtt`,{
        clientId:'web_' + localStorage.getItem('did') + Math.random().toString(16).substr(2,6),
        username:'zjl',
        password:'12345678',
        clean:true
      });
      this.client.on('connect',() => {
        console.log('已连接');
        // 批量订阅
        this.client.subscribe(this.topics,{qos:1},(err) => {
          if (err) {
            console.error('订阅失败:',err);
          } else {
            console.log('批量订阅成功:',this.topics);
          }
        });
      });

      this.client.on('message',(topic,message) => {
        const data = message.toString();
        console.log("mqtt_msg",data);
        //this.$set(this.messages,topic,data);  // Vue2 响应式更新
        this.initWebData(data);
      });

      this.client.on('error',(err) => {
        console.error('连接错误:',err);
      });
    },
    initWebData(data) {
      try {
        data = JSON.parse(data);
      } catch (e) {
        console.error('MQTT 消息解析失败:',data);
        return;
      }
      if (Array.isArray(data)) {
        this.upStateBatch(data);
      } else {
        this.upState(data);
      }
      /* MQTT 状态更新后同步刷新弹窗中的设备数据 */
      this.updateDialogSiteData();
    },
    upStateBatch(dataArr) {
      const indexMap = new Map();
      this.sites.forEach((site,idx) => {
        indexMap.set(site.wg_mac.toLowerCase() + '_' + String(site.wg_qid),idx);
      });

      dataArr.forEach(data => {
        const key = data.wg_mac.toLowerCase() + '_' + String(data.wg_qid);
        const idx = indexMap.get(key);
        if (idx !== undefined) {
          this.$set(this.sites,idx,this.processSiteState(this.sites[idx],data));
        }
        // console.log("-------",this.sites);
      });
    },
    processSiteState(site,data) {
      const d_data = {
        ...site
      };
      if ("pwr" in data) {
        d_data['pwr'] = data.pwr;
        this.clearPending(site.id,'pwr');
      }
      if ("mode" in data) {
        d_data['mode'] = data.mode;
        this.clearPending(site.id,'mode');
      }
      if ("fan" in data) {
        d_data['fan'] = data.fan;
      }
      if ("fan_set" in data) {
        d_data['fan_set'] = data.fan_set;
        this.clearPending(site.id,'fan_set');
      }
      if ("temp" in data) {
        d_data['temp'] = data.temp;
      }
      if ("temp_set" in data) {
        d_data['temp_set'] = data.temp_set;
        this.clearPending(site.id,'temp_set');
      }
      if ("sf_pwr" in data) {
        d_data['sf_pwr'] = data.sf_pwr;
      }
      if ("online" in data) {
        d_data['online'] = data.online;
      }
      if ("uptime" in data) {
        d_data['uptime'] = data.uptime;
      }
      if ("kt_lock" in data) {
        /* 发送温度限制后，忽略首次自动下发的半锁状态，保持原锁定状态 */
        const preservedLock = this.tempLimitLockPreserve[d_data.id];
        if (preservedLock !== undefined) {
          d_data['kt_lock'] = preservedLock;
          this.$delete(this.tempLimitLockPreserve,d_data.id);
        } else {
          d_data['kt_lock'] = data.kt_lock;
        }
      }
      return this.upMsgParse(d_data,data);
    },
    upMsgParse(d_data,old_d) {
      if ("temp" in old_d) {
        d_data["temp"] = d_data["temp"] / 10;
      }
      if ("temp_set" in old_d) {
        d_data["temp_set"] = d_data["temp_set"] / 10;
      }

      if (this.pidSj.includes(d_data.pid)) {
        if ("mode" in old_d) {
          if (d_data["mode"] === 3) {
            d_data["mode"] = 2;
          } else if (d_data["mode"] === 9) {
            d_data["mode"] = 3;
          }
        }
      } else if (d_data.pid === "sj_hw") {
        if ("mode" in old_d) {
          if (d_data["mode"] === 2) {
            d_data["mode"] = 1;
          }
        }
        if ("kt_lock" in old_d) {
          d_data['kt_lock'] = d_data['sf_pwr'];
        }
      }

      if ("kt_lock" in old_d) {
        if (d_data['kt_lock']) {
          if (d_data['kt_lock'] === 0) { /*锁定*/
            d_data['bg_sd'] = this.bj_but_1;
            d_data['kt_lock'] = 0;
          } else {
            d_data['bg_sd'] = this.bj_but;
          }
        } else {
          d_data['bg_sd'] = this.bj_but_1;
          d_data['kt_lock'] = 0;
        }
      }
      if ("pwr" in old_d) {
        if (d_data['pwr'] === 1) { /*开关*/
          d_data['pwr'] = 1;
        } else {
          d_data['pwr'] = 0;
        }
      }
      if ("online" in old_d) {
        d_data['icon_pow'] = "pow_0";
        if (d_data['online'] === 88 || d_data['online'] === 66) { /*网关通讯状态*/
          d_data['online'] = 88;
          d_data['icon_tx'] = "tx";
          d_data['dev_status'] = this.$t('在线'); /*网关状态*/
          if (d_data['pwr'] === 1) { /*开关*/
            d_data['icon_pow'] = "pow_1";
          }
        } else if (d_data['online'] === 44) {
          d_data['icon_tx'] = "tx_-1";
          d_data['dev_status'] = this.$t('离线'); /*网关状态-内机离线*/
          d_data['icon_xh'] = "xh";
        } else {
          d_data['icon_tx'] = "tx_0";
          d_data['dev_status'] = this.$t('离线'); /*网关状态-网关离线*/
          d_data['icon_xh'] = "xh";
        }

        if (d_data['kt_err'] && d_data['kt_err'] !== "0") {
          if (!d_data['kt_err'].includes("00000000") && d_data['kt_err'] !== 'LOST') {
            d_data['icon_tx'] = "tx_-1";
            d_data['dev_status'] = this.$t('空调内机故障：') + d_data['kt_err'];/*网关状态-内机离线*/
          }
        }
        /* 设备离线时清除全部pending，避免状态一直卡住 */
        if ((d_data['online'] === -1 || d_data['online'] === 44) && d_data.id && this.pendingMap[d_data.id]) {
          this.clearAllPending(d_data.id);
        }
      }
      return d_data;
    },
    upState(data) {
      this.sites = this.sites.map(item => {
        if (item.wg_mac.toLowerCase() === data.wg_mac && String(item.wg_qid) === String(data.wg_qid)) {
          let d_data = {
            ...item
          };
          if ("pwr" in data) {
            d_data['pwr'] = data.pwr;
            this.clearPending(item.id,'pwr');
          }
          if ("mode" in data) {
            d_data['mode'] = data.mode;
            this.clearPending(item.id,'mode');
          }
          if ("fan" in data) {
            d_data['fan'] = data.fan;
          }
          if ("fan_set" in data) {
            d_data['fan_set'] = data.fan_set;
            this.clearPending(item.id,'fan_set');
          }
          if ("temp" in data) {
            d_data['temp'] = data.temp;
          }
          if ("temp_set" in data) {
            d_data['temp_set'] = data.temp_set;
            this.clearPending(item.id,'temp_set');
          }
          if ("sf_pwr" in data) {
            d_data['sf_pwr'] = data.sf_pwr;
          }
          if ("online" in data) {
            d_data['online'] = data.online;
          }
          if ("uptime" in data) {
            d_data['uptime'] = data.uptime;
          }
          if ("kt_lock" in data) {
            /* 发送温度限制后，忽略首次自动下发的半锁状态，保持原锁定状态 */
            const preservedLock = this.tempLimitLockPreserve[d_data.id];
            if (preservedLock !== undefined) {
              d_data['kt_lock'] = preservedLock;
              this.$delete(this.tempLimitLockPreserve,d_data.id);
            } else {
              d_data['kt_lock'] = data.kt_lock;
            }
          }
          return this.upMsgParse(d_data,data);
        }
        return item;
      });
    },
    change_bj(i) {
      if (i === "1") { /*console.log("白色")*/
        this.id = "devControl_1";
        this.my_treeCtr = "my_treeCtr_1";
        this.li_head = "li_head_1";
        this.man_li = "man_li_1";
        this.my_main = "my_main_1";
        this.head_liman = "head_liman_1";
        this.grid_box = "grid_box_1";
        this.grid_item = "grid_item_1";
        this.bj_daiLog = "data-dialog_1";
        this.bj_table = "myTable_data_1";
        this.bj_but = "#409EFF";
        this.bj_but_color = "#000000";
        this.bj_but_1 = "#FFFFFF";
        this.dailog_qxbg = "#FFFFFF";
        this.dailog_qdbg = "#FFFFFF";
        this.dailog_qxbg_color = "#000000";
        this.dailog_qdbg_color = "#000000";
        this.bj_tab = "#FFFFFF";
        this.bj_dev_txt = "#000000";
        this.bj_tab_color = "#000000";
        this.bj_txt_line6 = "#000000";
      } else { /*console.log("黑色")*/
        this.id = "devControl";
        this.my_treeCtr = "my_treeCtr";
        this.li_head = "li_head";
        this.man_li = "man_li";
        this.my_main = "my_main";
        this.head_liman = "head_liman";
        this.grid_box = "grid_box";
        this.grid_item = "grid_item";
        this.bj_daiLog = "data-dialog";
        this.bj_table = "myTable_data";
        this.bj_but = "#409EFF";
        this.bj_but_color = "#FFFFFF";
        this.bj_but_1 = "#283A4D";
        this.dailog_qxbg = "#283A4D";
        this.dailog_qdbg = "#283A4D";
        this.dailog_qxbg_color = "#FFFFFF";
        this.dailog_qdbg_color = "#FFFFFF";
        this.bj_tab = "#283A4D";
        this.bj_dev_txt = "#ccc";
        this.bj_tab_color = "#FFFFFF";
        this.bj_txt_line6 = "#FFFFFF";
      }
    }
  },
  created() {
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.$urls.webMsg = localStorage.getItem("webMsg");
    console.log(this.$urls.webMsg);
    this.webConect();
  },
  mounted() { /*页面显示时调用*/
    this.bj = localStorage.getItem('bj');
    this.change_bj(this.bj); /*修改背景*/
    this.get_area_list();
    this.initHead();
    if (parseInt(localStorage.getItem("kt_qx")) !== 0) {
      this.kt_qx = false;
    }
    this.loading = this.$loading({spinner:"",text:"正在加载中...",background:"rgba(0, 0, 0, 0.3)"});
    this.get_devType();
    this.getDevData();
    this.xhTime(); /*启动轮询*/
  },
  computed:{ /*定义计算属性-响应数据改变后重新计算*/
    fil_floor() {
      return this.list_floor.filter(item => {
        return !(this.edi_unit && parseInt(item.unit_id) !== parseInt(this.edi_unit));
      });
    },
    fil_room() {
      return this.list_room.filter(item => {
        return !(this.edi_floor && parseInt(item.floor_id) !== parseInt(this.edi_floor));
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面切换时调用*/
    if (this.client) this.client.end();
    clearInterval(this.timer);
    clearInterval(this.intervalId);
    clearInterval(this.timer_pwr);
    clearInterval(this.timer_mode);
    clearInterval(this.timer_fan);
    clearInterval(this.timer_wd);
    clearInterval(this.timer_temp);
    this.timer = null;
    this.intervalId = null;
    /* 页面销毁时清空全部 pending 避免内存泄漏 */
    Object.keys(this.pendingMap).forEach(siteId => {
      this.clearAllPending(parseInt(siteId));
    });
  }
};
</script>

<style scoped>
@import '../../assets/css/aTab.css';
@import '../../assets/css/icon_self.css';

#devControl {
  height: 100vh;
  background: #283A4D;
  margin: 0;
  padding: 0;
}

#devControl_1 {
  height: 100vh;
  background: #F4F4F4;
  margin: 0;
  padding: 0;
}

.li_head {
  background-color: #283A4D;
  color: #ffffff;
  height: 50px;
  text-align: left;
  line-height: 60px;
  min-height: 1vh;
}

.li_head_1 {
  background-color: #F4F4F4;
  color: #000000;
  height: 50px;
  text-align: left;
  line-height: 60px;
  min-height: 1vh;
}

.my_main {
  height: 100vh;
  background: #283A4D
}

.my_main_1 {
  height: 100vh;
  background: #F4F4F4
}

.man_li {
  background: #F4F4F4;
  color: #ffffff;
}

.man_li_1 {
  background: #F4F4F4;
  color: #000000;
}

.my_treeCtr { /*width: 10vw;*/
  background-color: #283A4D !important;
  height: 95vh;
  color: #409EFF;
  overflow-y: auto; /*设置超出屏幕滚轮自动出现*/

  .my-tree-node__content:hover { /* 鼠标浮动过的背景颜色 */
    /*background: #409EFF;*/
    color: #409EFF;
  }

  .my-tree-node:focus > .my-tree-node__content { /* 鼠标点击时节点的背景颜色 */
    /* background-color: #409EFF !important;*/
    color: #409EFF;
  }
}

.my_treeCtr_1 { /*width: 10vw;*/
  background-color: #F4F4F4 !important;
  height: 95vh;
  color: #000000;
  overflow-y: auto; /*设置超出屏幕滚轮自动出现*/

  .my-tree-node__content:hover { /* 鼠标浮动过的背景颜色 */
    /*background: #409EFF;*/
    color: #409EFF;
  }

  .my-tree-node:focus > .my-tree-node__content { /* 鼠标点击时节点的背景颜色 */
    /* background-color: #409EFF !important;*/
    color: #409EFF;
  }
}

.head_liman {
  background: #283A4D;
}

.head_liman_1 {
  background: #F4F4F4;
}

.head_liman::-webkit-scrollbar, .head_liman_1::-webkit-scrollbar, .my-tree::-webkit-scrollbar, .my-tree_1::-webkit-scrollbar {
  width: 8px;
}

.head_liman::-webkit-scrollbar-thumb, .head_liman_1::-webkit-scrollbar-thumb, .my-tree::-webkit-scrollbar-thumb, .my-tree_1::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #0dA7C8;
}

.head_liman::-webkit-scrollbar-track, .head_liman_1::-webkit-scrollbar-track, .my-tree::-webkit-scrollbar-track, .my-tree_1::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

.grid_box { /*表格式布局*/
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  grid-auto-flow: row; /*改为先列后行 column*/
  column-gap: 6px; /*行列间距*/
  row-gap: 10px;
  /*grid-template-pageSize: repeat(auto-fill, 300px); !*设置高度限制*!*/
  /*justify-content: center; align-content: center; !*居中显示*!*/
}


.grid_box_1 { /*表格式布局*/
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  grid-auto-flow: row; /*改为先列后行 column*/
  column-gap: 6px; /*行列间距*/
  row-gap: 10px;
  background: #F4F4F4;
  /*grid-template-pageSize: repeat(auto-fill, 300px); !*设置高度限制*!*/
  /*justify-content: center; align-content: center; !*居中显示*!*/
}

.grid_item {
  /*font-size: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;*/
}

.grid_item_1 {
  /*font-size: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;*/
}

.hoverElement:hover {
  background-color: #0dA7C8; /* 鼠标悬停时的背景色 */
}

input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}

input[type="number"] {
  -moz-appearance: textfield;
}

/* ========== Thermostat 温控器样式 (#283A4D 暗色主题) ========== */

/* --- 卡片外壳 --- */
.thermostat-container {
  border-radius: 16px;
  padding: 12px;
  font-family: "Microsoft YaHei", "Heiti SC", sans-serif;
  background: linear-gradient(145deg, #1C2E42 0%, #223244 100%);
  border: 1px solid #3A506B;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3),
  inset 0 1px 0 rgba(255, 255, 255, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.thermostat-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4),
  inset 0 1px 0 rgba(255, 255, 255, 0.08);
  border-color: #4A6582;
}

/* --- 顶部状态栏 --- */
.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  min-height: 24px;
}

.left-group {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
}

.id-badge {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}

.id-text {
  color: #8DA5BE;
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
}

.id-text-on {
  color: #FFFFFF;
}

.id-text:hover {
  color: #E8F0F8;
}

.power-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  flex-shrink: 0;
  color: #888;
}

/* --- 中心显示屏 --- */
.display-screen {
  background: #121D2B;
  border: 1px solid #1E2F42;
  border-radius: 12px;
  padding: 12px;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

/* 屏幕开启时的微光效果 */
.display-screen.screen-on::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(ellipse at 30% 20%, rgba(0, 231, 255, 0.06) 0%, transparent 60%);
  pointer-events: none;
}

/* 电源打开时的亮色屏幕 */
.display-screen.screen-on {
  background: #121D2B;
  border-color: #1E2F42;
}

/* 离线状态 */
.display-screen.offline {
  opacity: 0.55;
}

.display-screen.offline .big-num {
  color: #4A5A6A !important;
}

.display-screen.offline .temp-unit span:first-child {
  color: #4A5A6A !important;
}

/* 屏幕内部布局 */
.display-top {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.mode-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.setting-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.t-label {
  color: #5A7391;
  display: block;
  font-size: 11px;
}

/* --- 主温度数字 --- */
.main-temp {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: -4px 0 12px 0;
}

.big-num {
  font-size: 40px;
  font-weight: 700;
  line-height: 1;
  color: #4A5A6A;
  letter-spacing: 2px;
}

/* 开机时温度数字 - 亮青色 */
.display-screen.screen-on .big-num {
  color: #00E5FF;
  text-shadow: 0 0 20px rgba(0, 229, 255, 0.3), 0 0 60px rgba(0, 229, 255, 0.1);
}

.temp-unit {
  font-size: 14px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.temp-unit > span:first-child {
  color: #4A5A6A;
}

.display-screen.screen-on .temp-unit > span:first-child {
  color: #00E5FF;
  opacity: 0.7;
}

.sub-label {
  display: block;
  color: #5A7391;
  font-size: 11px;
}

.display-screen.screen-on .sub-label {
  color: #FFFFFF;
}

.display-bottom {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #5A7391;
  border-top: 1px solid #1A2638;
  padding-top: 8px;
  margin-top: 4px;
}

.display-screen.screen-on .display-bottom {
  color: #5A7391;
}

/* 关机时设定温度颜色与风速文字一致 */
.setting-section > span:last-child {
  color: #5A7391;
}

/* 开机时模式、设定温度、在线、时间、风速高亮为白色 */
.mode-text {
  color: #5A7391;
}

.display-screen.screen-on .mode-section .t-label,
.display-screen.screen-on .mode-section .mode-text,
.display-screen.screen-on .setting-section .t-label,
.display-screen.screen-on .setting-section > span:last-child,
.display-screen.screen-on .display-bottom span {
  color: #FFFFFF;
}

/* --- 底部按钮组 --- */
.button-group {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  gap: 8px;
}

.control-btn {
  flex: 1;
  height: 36px;
  background: linear-gradient(145deg, #1A2838 0%, #1E2D3D 100%);
  border: 1px solid #2E4056;
  border-radius: 8px;
  color: #4A6582;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.15s ease;
  padding: 0;
}

/* 开机状态：仅图标高亮 */
.screen-on + .button-group .control-btn {
  color: #C0D8E8;
}

.control-btn:hover {
  border-color: #0DA7C8;
  color: #E8F0F8;
  background: linear-gradient(145deg, #162536 0%, #1A2B3C 100%);
  box-shadow: 0 0 10px rgba(13, 167, 200, 0.15);
}

.control-btn:active {
  transform: scale(0.95);
}

.control-btn .icon {
  color: inherit;
}

/* --- 离线状态样式 --- */
.offline-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}

.offline-icon {
  font-size: 40px;
  color: #3A4A5A;
  height: 45px;
  width: 45px;
  margin-bottom: 4px;
}

.offline-text {
  font-size: 14px;
  color: #3A4A5A;
  font-weight: bold;
  height: 24px;
}

/* ========== 温控器浅色主题 (bj="1", 背景 #F4F4F4) ========== */

/* 卡片外壳 */
.grid_item_1 .thermostat-container {
  background: linear-gradient(145deg, #F8F9FA 0%, #EDEFF2 100%);
  border: 1px solid #C8CDD4;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.grid_item_1 .thermostat-container:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.8);
  border-color: #B0B7C0;
}

/* 名称 */
.grid_item_1 .id-text {
  color: #5A6B7C;
}

.grid_item_1 .id-text:hover {
  color: #283A4D;
}

/* 显示屏 */
.grid_item_1 .display-screen {
  background: #A8B0A0;
  border-color: #9AA290;
}

.grid_item_1 .display-screen.screen-on {
  background: #E8EAE6;
  border-color: #C0C8C0;
  box-shadow: inset 0 0 16px rgba(0, 0, 0, 0.04);
}

.grid_item_1 .display-screen.screen-on::after {
  background: radial-gradient(ellipse at 30% 20%, rgba(13, 167, 200, 0.04) 0%, transparent 60%);
}

.grid_item_1 .display-screen.offline {
  opacity: 0.5;
}

/* 文字颜色 */
.grid_item_1 .t-label {
  color: #6B767E;
}

.grid_item_1 .big-num {
  color: #8A928A;
}

.grid_item_1 .display-screen.screen-on .big-num {
  color: #0DA7C8;
  text-shadow: 0 0 16px rgba(13, 167, 200, 0.2), 0 0 40px rgba(13, 167, 200, 0.06);
}

.grid_item_1 .temp-unit > span:first-child {
  color: #8A928A;
}

.grid_item_1 .display-screen.screen-on .temp-unit > span:first-child {
  color: #0DA7C8;
  opacity: 0.7;
}

.grid_item_1 .sub-label {
  color: #6B767E;
}

.grid_item_1 .display-screen.screen-on .sub-label {
  color: #283A4D;
}

.grid_item_1 .display-bottom {
  color: #6B767E;
  border-top-color: rgba(0, 0, 0, 0.08);
}

.grid_item_1 .display-screen.screen-on .display-bottom {
  color: #6B767E;
}

.grid_item_1 .setting-section > span:last-child {
  color: #6B767E;
}

.grid_item_1 .mode-text {
  color: #6B767E;
}

.grid_item_1 .display-screen.screen-on .mode-section .t-label,
.grid_item_1 .display-screen.screen-on .mode-section .mode-text,
.grid_item_1 .display-screen.screen-on .setting-section .t-label,
.grid_item_1 .display-screen.screen-on .setting-section > span:last-child,
.grid_item_1 .display-screen.screen-on .display-bottom span {
  color: #283A4D;
}

/* 离线 */
.grid_item_1 .display-screen.offline .big-num {
  color: #A0A8A0 !important;
}

.grid_item_1 .display-screen.offline .temp-unit span:first-child {
  color: #A0A8A0 !important;
}

/* 底部按钮 */
.grid_item_1 .control-btn {
  background: linear-gradient(145deg, #E8EAED 0%, #DEE0E4 100%);
  border-color: #B8BEC6;
  color: #909AA6;
}

.grid_item_1 .screen-on + .button-group .control-btn {
  color: #3A5A6E;
}

.grid_item_1 .control-btn:hover {
  border-color: #0DA7C8;
  color: #283A4D;
  background: linear-gradient(145deg, #D8E4E8 0%, #D0DCE2 100%);
  box-shadow: 0 0 10px rgba(13, 167, 200, 0.12);
}

/* 离线状态 */
.grid_item_1 .offline-icon {
  color: #B0B8B0;
}

.grid_item_1 .offline-text {
  color: #B0B8B0;
}


</style>



// WEBPACK FOOTER //
// src/pages/ctrol/ctrKt.vue